// import React, { useContext, useEffect, useState } from "react";
// import AdminContext from "../../admin/StateContext/Application";
// import ReactApexChart from "react-apexcharts";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import "./agencydashboard.css";
// import Select from "react-select";
// import { apiurl } from "../../../path";

// // 07-10 for img slide 

// import {
//   FaMapMarkerAlt,
//   FaRegCalendarAlt,
//   FaRegClock,
//   FaMountain,
//   FaBullseye,
//   FaChartBar,
//   FaChevronLeft,
//   FaChevronRight,
// } from "react-icons/fa";
// import { TbLocation } from "react-icons/tb";

// import {
//   Approved32,
//   Click32,
//   Disable32,
//   Earnings,
//   Earningss,
//   Earningsss,
//   Error32,
//   fifth,
//   first,
//   forth,
//   Graph64,
//   MoreMenu64,
//   NewTasks64,
//   Sales,
//   Second,
//   Spendthismonth64,
//   third,
//   TotalProjects64,
//   Unclick32,
//   YourBalance,
//   ECSFile,
//   TotalAmountRelease,
//   TotalDeductionAmount,
//   TotalDemandGenerations,
//   TotalWorkOrders,
//   TotalProjectCost,
//   TotalEsitmateAmount,
//   TotalHeadsAssigns,
//   DeleteIcon,
//   EditIcon,
// } from "../../../public/LoginImages/importimages";
// // import '../../Users/pages/innercss.css'
// // import { options } from '../../../../../backend/routes/admin/Login';
// const AgencyDashboard = () => {


//    //07-10 for img slide
//   const [currentSlide, setCurrentSlide] = useState(0);
//     const CARD_THEMES = [
//     { border: "#3b82f6", bg: "#f3f8ff", iconBg: "#dbeafe", icon: "#3b82f6" }, // blue
//     { border: "#8b5cf6", bg: "#f6f4ff", iconBg: "#e9e4ff", icon: "#8b5cf6" }, // purple
//     { border: "#22a55a", bg: "#f2fbf5", iconBg: "#d5f3e0", icon: "#22a55a" }, // green
//     { border: "#f59e0b", bg: "#fffaf0", iconBg: "#fdebc8", icon: "#f59e0b" }, // orange
//   ];
  
//   const InfoRow = ({ icon, label, value, theme }) => (
//     <div
//       style={{
//         display: "flex",
//         alignItems: "center",
//         gap: "8px",
//         marginBottom: "7px",
//         fontSize: "11px",
//       }}
//     >
//       <span
//         style={{
//           width: "20px",
//           height: "20px",
//           borderRadius: "50%",
//           backgroundColor: theme.iconBg,
//           color: theme.icon,
//           display: "inline-flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontSize: "10px",
//           flexShrink: 0,
//         }}
//       >
//         {icon}
//       </span>
//       <span>
//         <b>{label}:</b> {value}
//       </span>
//     </div>
//   );
//   // -----------------

//   const content = useContext(AdminContext);
//   const {
//     Usermenu,
//     GetAgnecyWiseTaxAmount,
//     GetVendorBills,
//     GetProjectInfo,
//     getTaxAmountsByDate,
//     GetAgencyWiseData,
//     GetBudgetHeadInfo,
//     GetAgencyDashboardData,
//   } = content;
//   const [getData, SetData] = useState({});
//   const [menuData, setMenuData] = useState({});
//   const [vendorbills, setVendorBills] = useState([]);
//   const [taxesData, SetTaxesData] = useState({});
//   const [loading, setloading] = useState(true);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [dateData, setDateData] = useState([]);
//   const [projectdata, setProjectData] = useState([]);
//   const [projectId, setProjectId] = useState("");
//   const [headFetchedData, setHeadFetchedData] = useState([]);
//   const [headEstimationData, setHeadEstimationData] = useState([]);
//   const [headId, setheadId] = useState("");
//   const [allProjects, setAllProjects] = useState([]);
//   const [filteredProjects, setFilteredProjects] = useState([]);
//   const [deductionData, setDeductionData] = useState([]);
//   const [scheme, setScheme] = useState("");
//    const [FetchedImages, setFetchedImages] = useState([]);
//      const [selectedImage, setSelectedImage] = useState(null);
//      const [selectedUploadId, setSelectedUploadID] = useState();
//    const [showSpecific, setShowSpecific] = useState(0);
//   const [showTable, setShowTable] = useState(null);
//   const [progressData, setProgressData] = useState([]);
//   const [estimateData, setEstimateData] = useState([]);

//   const [demandTableData, setDemandTableData] = useState([]);
//   const [demandGenerationData, setDemandGenerationData] = useState([]);
//   const [releaseData, setReleaseData] = useState({
//     ReleaseAmountTillDate: 0,
//   });
//   const [releaseAmountData, setReleaseAmountData] = useState([]);
//   const [deductionWorkOrders, setDeductionWorkOrders] = useState([]);
//   const [deductionDetails, setDeductionDetails] = useState([]);
//   const [selectedWorkOrder, setSelectedWorkOrder] = useState("");

//   const fmt = (n) => Number(n || 0).toLocaleString("en-IN");


//   const isAgencyMaker =
//     menuData?.Department_Name === "Agency Maker" &&
//     menuData?.Role === "Agency Maker";

//   const isAgencyAdmin =
//     menuData?.Department_Name === "Agency Admin" &&
//     menuData?.Role === "Agency Admin";

//   const isAgencyChecker =
//     menuData?.Department_Name === "Agency Checker" &&
//     menuData?.Role === "Agency Checker";

//   const canViewProjectSelect =
//     isAgencyMaker || isAgencyAdmin || isAgencyChecker;

//   const getLoggedInAgencyCode = () => {
//     try {
//       const token = localStorage.getItem("Token");
//       if (!token) {
//         console.log("Token not found");
//         return "";
//       }

//       const payload = JSON.parse(atob(token.split(".")[1]));

//       console.log("Logged-in Agency Code:", payload.Agency);

//       return payload.Agency || "";
//     } catch (error) {
//       console.error("Error reading agency from token:", error);
//       return "";
//     }
//   };

//   // const agencyCode = getLoggedInAgencyCode();

//   const COLORS = {
//     purple: "#6656db",
//     blue: "#3cb9e8",
//     aqua: "#26e1d0",
//     green: "#38d1bd",
//     background: "#efecff",
//     gray: "#f7f8fa",
//     darkblue: "#054ecf",
//   };

//   const cardStyle = {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-start",
//     gap: "10px",
//     borderRadius: 15,
//     padding: "15px 20px",
//     color: "#fff",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//     height: "120px",
//     width: "367px",
//     margin: "0px",
//   };
//   const cardStyleMiddle = {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-start",
//     gap: "15px",
//     borderRadius: 15,
//     padding: "15px 20px",
//     color: "#fff",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//     height: "120px",
//     width: "400px",
//   };

//   const cardImage = {
//     width: "60px",
//     height: "60px",
//     borderRadius: "8px",
//     background: "rgba(255,255,255,0.2)",
//   };
//   const cardChartStyle = {
//     background: "#fff",
//     borderRadius: "15px",
//     padding: "20px",
//     boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//     display: "flex",
//     flexDirection: "column",
//     gap: "10px",
//     minHeight: "350px",
//   };
//   const buttonStyle = {
//     border: "none",
//     backgroundColor: "#e0e7ff",
//     color: "#3b82f6",
//     padding: "6px 15px",
//     borderRadius: "8px",
//     fontSize: "13px",
//     fontWeight: 600,
//     cursor: "pointer",
//   };

//   useEffect(() => {
//     GetAmountOfTaxes();
//     // getVendorbill()
//     getTaxesAmountbyDate();
//     GetAllProjectTotal();
//     GetHeadBuget();
//     // GetAgencyDashboardData();
//   }, []);
//   useEffect(() => {
//     const getMenu = async () => {
//       const res = await Usermenu();
//       console.log("menuData", res);
//       setMenuData(res?.Data || {});
//     };

//     getMenu();
//   }, []);

//   const agencyCode = getLoggedInAgencyCode();

//   // 02-10
//   const [searchText, setSearchText] = useState("");
 
// const filterBySearch = (rows, keys) => {
//   const q = searchText.trim().toLowerCase();
//   const list = Array.isArray(rows) ? rows : [];
//   if (!q) return list;
//   return list.filter((item) =>
//     keys.some((k) => String(item?.[k] ?? "").toLowerCase().includes(q))
//   );
// };
// useEffect(() => {
//   setSearchText("");
// }, [showTable, selectedWorkOrder]);
// useEffect(() => {
//   setProjectCostCurrentPage(1);
//   setEstimateCurrentPage(1);
//   setProgressCurrentPage(1);
//   setWorkOrderCurrentPage(1);
//   setDemandCurrentPage(1);
//   setDeductionWorkOrderCurrentPage(1);
//   setDeductionDetailsCurrentPage(1);
//   setReleaseAmountCurrentPage(1);
// }, [searchText]);

//   const loadDashboardData = async (selectedProjectId = "") => {
//     try {
//       if (!agencyCode) return;

//       console.log("Loading Dashboard Data");
//       console.log("Agency:", agencyCode);
//       console.log("Project:", selectedProjectId);

//       const estimate = await GetAgencyDashboardData({
//         agencyCode,
//         projectId: selectedProjectId,
//         type: "estimate",
//       });

//       const workorder = await GetAgencyDashboardData({
//         agencyCode,
//         projectId: selectedProjectId,
//         type: "workorder",
//       });

//       console.log("ESTIMATE DATA:", estimate);
//       console.log("WORK ORDER DATA:", workorder);

//       setEstimateData(Array.isArray(estimate) ? estimate : []);

//       setWorkOrderData(Array.isArray(workorder) ? workorder : []);
//     } catch (error) {
//       console.error("Dashboard Data Error:", error);

//       setEstimateData([]);
//       setWorkOrderData([]);
//     }
//   };

//   useEffect(() => {
//     if (!agencyCode) return;

//     loadDashboardData(projectId || "");
//   }, [projectId, agencyCode]);

//   useEffect(() => {
//     const loadAgencyProjects = async () => {
//       if (!agencyCode) {
//         console.log("No agencyCode");
//         return;
//       }

//       try {
//         const data = await GetAgencyDashboardData({
//           agencyCode,
//           type: "project",
//           projectId: "",
//         });

//         console.log("AGENCY PROJECTS:", data);

//         const projects = Array.isArray(data) ? data : [];

//         setProjectData(projects);
//         setFilteredProjects(projects);
//       } catch (error) {
//         console.error("Agency projects error:", error);

//         setProjectData([]);
//         setFilteredProjects([]);
//       }
//     };

//     loadAgencyProjects();
//   }, [agencyCode]);

//   useEffect(() => {
//     const loadProgressReport = async () => {
//       if (!agencyCode) {
//         console.log("No agency code");
//         return;
//       }
//       try {
//         console.log("🔥 Loading Progress Report");
//         console.log("Agency:", agencyCode);
//         console.log("Project:", projectId);
//         const response = await GetAgencyDashboardData({
//           agencyCode,
//           projectId: projectId || "",
//           type: "progress",
//         });
//         console.log("🔥 PROGRESS RESPONSE:", response);
//         // setProgressData(Array.isArray(response?.data) ? response.data : []);
//         setProgressData(Array.isArray(response) ? response : []);
//         // console.log("FINAL PROGRESS ARRAY:", response);
//         console.log(
//           "FINAL PROGRESS ARRAY:",
//           Array.isArray(response) ? response : [],
//         );
//       } catch (error) {
//         console.error("PROGRESS ERROR:", error);
//         setProgressData([]);
//       }
//     };
//     loadProgressReport();
//   }, [projectId, agencyCode]);

  

//   useEffect(() => {
//     const loadWorkOrder = async () => {
//       if (!agencyCode) {
//         console.log("No agency code");
//         return;
//       }

//       try {
//         console.log("🔥 Loading Work Orders");
//         console.log("Agency:", agencyCode);
//         console.log("Project:", projectId);

//         const data = await GetAgencyDashboardData({
//           agencyCode: agencyCode,
//           projectId: projectId || "",
//           type: "workorder",
//         });

//         console.log("🔥 WORK ORDER DATA:", data);

//         setWorkOrderData(Array.isArray(data) ? data : []);

//         // Reset pagination whenever API data changes
//         setWorkOrderCurrentPage(1);
//       } catch (error) {
//         console.error("WORK ORDER ERROR:", error);
//         setWorkOrderData([]);
//       }
//     };

//     loadWorkOrder();
//   }, [projectId, agencyCode]);

//   useEffect(() => {
//     const loadDemandGeneration = async () => {
//       if (!agencyCode) {
//         console.log("No agency code");
//         return;
//       }

//       try {
//         console.log("🔥 Loading Demand Generation");
//         console.log("Agency:", agencyCode);
//         console.log("Project:", projectId);

//         const data = await GetAgencyDashboardData({
//           agencyCode: agencyCode,
//           projectId: projectId || "",
//           type: "demand",
//         });

//         console.log("🔥 DEMAND GENERATION DATA:", data);

//         setDemandGenerationData(Array.isArray(data) ? data : []);
//       } catch (error) {
//         console.error("DEMAND GENERATION ERROR:", error);

//         setDemandGenerationData([]);
//       }
//     };

//     loadDemandGeneration();
//   }, [projectId, agencyCode]);

//   useEffect(() => {
//     const loadReleaseAmount = async () => {
//       if (!agencyCode) return;

//       try {
//         const data = await GetAgencyDashboardData({
//           agencyCode,
//           projectId: projectId || "",
//           type: "releaseamount",
//         });

//         console.log("RELEASE DATA:", data);

//         setReleaseAmountData(Array.isArray(data) ? data : []);
//       } catch (error) {
//         console.error(error);
//         setReleaseAmountData([]);
//       }
//     };

//     loadReleaseAmount();
//   }, [projectId, agencyCode]);

//   const selectedEstimateData = estimateData.filter(
//     (item) => String(item.ProjectID) === String(projectId),
//   );

//   console.log("SELECTED ESTIMATE DATA:", selectedEstimateData);

//   const filteredData = headId
//     ? headFetchedData.filter((item) => item.HeadID == headId)
//     : headFetchedData;

//   console.log("filteredDataaa: ", filteredData);
//   const GetAmountOfTaxes = async () => {
//     let data = await GetAgnecyWiseTaxAmount();
//     console.log(data);
//     SetData((prevState) => {
//       return data;
//     });

//     setloading(false);
//   };

//   const GetAllProjectTotal = async () => {
//     try {
//       // Fetch ALL projects initially
//       const data = await GetProjectInfo("", "getProjectsByHead");
//       console.log("All projects fetched:", data);
//       const projects = Array.isArray(data) ? data : [];
//       console.log("PROJECT DATA:-->", projects);
//       const uniqueProjects = Array.from(
//         new Map(
//           projects.map((project) => [project.ProjectId, project]),
//         ).values(),
//       );

//       setProjectData(uniqueProjects);
//       setFilteredProjects(uniqueProjects);
//     } catch (err) {
//       console.error("Error fetching projects:", err);
//       setProjectData([]);
//       setFilteredProjects([]);
//     }
//   };

//   const getVendorbill = async () => {
//     let data1 = await GetVendorBills();
//     // setVendorBills(data1)
//     console.log(projectId);
//     let bills = data1.filter((item) => item.BillNumber == projectId);
//     console.log(bills);

//     setVendorBills(bills);
//     // setloading(false);
//   };
//   let vendorBillList = [];
//   if (vendorbills.length > 0) {
//     vendorBillList = vendorbills;
//   }

//   const getTaxesAmountbyDate = async () => {
//     let data = await getTaxAmountsByDate();
//     console.log(data);
//   };
//   const [state, setState] = React.useState({
//     series: [
//       {
//         name: "High - 2013",
//         data: [28, 29, 33, 36, 32, 32, 33],
//       },
//       {
//         name: "Low - 2013",
//         data: [12, 11, 14, 18, 17, 13, 13],
//       },
//     ],
//     options: {
//       chart: {
//         height: 280,
//         type: "line",
//         dropShadow: {
//           enabled: true,
//           top: 8,
//           left: 3,
//           blur: 6,
//           opacity: 0.25,
//           color: "#7f47dd", // this will reflect dynamically per series below
//         },
//         zoom: {
//           enabled: false,
//         },
//         toolbar: {
//           show: false,
//         },
//       },
//       colors: ["#7f47dd", "#407fe4"], // base colors for each line
//       dataLabels: {
//         enabled: false,
//       },
//       fill: {
//         type: "gradient",
//         gradient: {
//           shade: "light",
//           type: "vertical",
//           shadeIntensity: 0.5,
//           gradientToColors: ["#cadbf8", "#d5b7ad"],
//           inverseColors: false,
//           opacityFrom: 0.5,
//           opacityTo: 0,
//           stops: [0, 100],
//         },
//       },
//       stroke: {
//         width: [7, 7],
//         curve: "straight", // plain line (no smooth curve)
//       },

//       grid: {
//         borderColor: "#e5e7eb",
//         row: { colors: ["#f9fafb", "transparent"], opacity: 0.5 },
//       },
//       markers: { size: 5 },
//       tooltip: {
//         enabled: true,
//         theme: "dark",
//       },
//       animations: {
//         enabled: true,
//         easing: "easeinout",
//         speed: 800,
//         animateGradually: {
//           enabled: true,
//           delay: 150,
//         },
//       },
//       xaxis: {
//         // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
//         categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
//         labels: { style: { colors: "#6b7280", fontSize: "12px" } },
//       },
//       yaxis: {
//         // min: 5,
//         // max: 40,
//         labels: { style: { colors: "#6b7280", fontSize: "12px" } },
//       },
//       legend: {
//         show: false,
//       },
//       responsive: [
//         {
//           breakpoint: 600,
//           options: {
//             chart: {
//               height: 300,
//             },
//             legend: {
//               position: "bottom",
//             },
//           },
//         },
//       ],
//     },
//   });
//   const [state1, setState1] = React.useState({
//     series: [
//       {
//         name: "PRODUCT A",
//         data: [44, 55, 41, 67, 22, 43],
//       },
//       {
//         name: "PRODUCT B",
//         data: [13, 23, 20, 8, 13, 27],
//       },
//       {
//         name: "PRODUCT C",
//         data: [11, 17, 15, 15, 21, 14],
//       },
//       {
//         name: "PRODUCT D",
//         data: [21, 7, 25, 13, 22, 8],
//       },
//     ],
//     options: {
//       chart: {
//         type: "bar",
//         height: 350,
//         stacked: true,
//         toolbar: {
//           show: false, // Hides the toolbar icons
//         },
//         zoom: {
//           enabled: true,
//         },
//       },
//       responsive: [
//         {
//           breakpoint: 480,
//           options: {
//             legend: {
//               position: "bottom",
//               offsetX: -10,
//               offsetY: 0,
//             },
//           },
//         },
//       ],
//       plotOptions: {
//         bar: {
//           horizontal: false,
//           borderRadius: 10,
//           dataLabels: {
//             total: {
//               enabled: true,
//               style: {
//                 fontSize: "13px",
//                 fontWeight: 900,
//               },
//             },
//           },
//         },
//       },
//       xaxis: {
//         type: "datetime",
//         categories: [
//           "01/01/2011 GMT",
//           "01/02/2011 GMT",
//           "01/03/2011 GMT",
//           "01/04/2011 GMT",
//           "01/05/2011 GMT",
//           "01/06/2011 GMT",
//         ],
//       },
//       yaxis: {
//         labels: {
//           show: false, // Hides y-axis numbering
//         },
//       },
//       legend: {
//         show: false, // Hides the legend
//       },

//       fill: {
//         opacity: 1,
//       },
//       colors: ["#442cfe", "#5937fd", "#50bdf5", "#cad1e0"],
//     },
//   });
//   const [state2, setState2] = React.useState({
//     series: [44, 55, 15],
//     options: {
//       chart: {
//         type: "donut",
//         width: 200,
//         height: 200,
//       },
//       labels: [
//         "Project Cost",
//         // "Esitmate Amount",
//         "Release Amount",
//         "Demand Generated",
//       ],

//       colors: ["#38d1bd", "#7f47dd", "#ee574c", "#50bdf5"],
//       legend: {
//         // show: false,
//         position: "bottom",
//         horizontalAlign: "center",
//         fontSize: "13px",
//         markers: { radius: 12, width: 12, height: 12 },
//       },
//       dataLabels: {
//         enabled: false,
//       },
//       responsive: [
//         {
//           breakpoint: 480,
//           options: {
//             chart: {
//               width: 100,
//               height: 100,
//             },
//             legend: {
//               position: "bottom",
//               show: false,
//             },
//           },
//         },
//       ],
//     },
//   });

//   // PIE CHART
//   const [state4, setState4] = React.useState({
//     series: [0, 0, 0, 0], // Default values to prevent errors
//     options: {
//       chart: { width: 250, type: "pie" },
//       labels: [
//         "Project Cost",
//         // "Esitmate Amount",
//         "Release Amount",
//         "Demand Generated",
//       ],
//       legend: {
//         position: "bottom",
//         horizontalAlign: "center",
//         fontSize: "13px",
//         markers: { radius: 12, width: 12, height: 12 },
//       },
//       dataLabels: { enabled: false },
//       colors: ["#38d1bd", "#50bdf5", "#ee574c", "#7f47dd"],
//       responsive: [
//         {
//           breakpoint: 480,
//           options: {
//             chart: { width: 200 },
//             legend: { position: "bottom" },
//           },
//         },
//       ],
//     },
//   });

//   useEffect(() => {
//     if (getData || dateData) {
//       setState4((prevState) => ({
//         ...prevState,
//         series: [
//           dateData.Project_Cost
//             ? dateData.Project_Cost
//             : getData.Project_Cost || 0,
//           // dateData.Esitmate_Amount
//           //   ? dateData.Esitmate_Amount
//           //   : getData.Esitmate_Amount || 0,
//           dateData.ReleaseAmountTillDate
//             ? dateData.ReleaseAmountTillDate
//             : getData.ReleaseAmountTillDate || 0,
//           dateData.LiabalityAmount
//             ? dateData.LiabalityAmount
//             : getData.LiabalityAmount || 0,
//           dateData.TotalWorkOrders
//             ? dateData.TotalWorkOrders
//             : getData.TotalWorkOrders || 0,
//         ],
//       }));
//     }
//   }, [getData, dateData]);

//   // PIE Chart 2
//   const [state5, setState5] = useState({
//     series: [], // Default values to prevent errors
//     options: {
//       chart: { width: 380, type: "pie" },
//       labels: [],
//       legend: {
//         position: "bottom",
//         horizontalAlign: "center",
//         fontSize: "14px",
//         markers: { radius: 12 },
//       },
//       responsive: [
//         {
//           breakpoint: 480,
//           options: {
//             chart: { width: 200 },
//             legend: { position: "bottom" },
//           },
//         },
//       ],
//     },
//   });

//   useEffect(() => {
//     if (deductionData && deductionData.length > 0) {
//       const totalAmount = deductionData.reduce(
//         (acc, item) => acc + parseFloat(item.TotalAmount),
//         0,
//       );

//       const labels = deductionData.map((item) => item.TypeOfAmount);
//       console.log("Labels -------------", labels);
//       const series = deductionData.map((item) => parseFloat(item.TotalAmount));

//       setState5((prev) => ({
//         ...prev,
//         series: series,
//         options: {
//           ...prev.options,
//           labels: labels,
//         },
//       }));
//     }
//   }, [deductionData]);

//   // Pagination logic for common ..not used
//   // const [currentPage, setCurrentPage] = useState(1);
//   // const totalPages = Math.ceil(vendorbills.length / billsPerPage);
//   // const indexOfLastBill = currentPage * billsPerPage;
//   // const indexOfFirstBill = indexOfLastBill - billsPerPage;
//   // const currentBills = vendorbills.slice(indexOfFirstBill, indexOfLastBill);

//   // ================= VENDOR BILL PAGINATION =================
//   const [vendorCurrentPage, setVendorCurrentPage] = useState(1);
//   const billsPerPage = 5;
//   const vendorTotalPages = Math.ceil(vendorbills.length / billsPerPage);
//   const vendorIndexOfLastBill = vendorCurrentPage * billsPerPage;
//   const vendorIndexOfFirstBill = vendorIndexOfLastBill - billsPerPage;
//   const currentBills = vendorbills.slice(
//     vendorIndexOfFirstBill,
//     vendorIndexOfLastBill,
//   );

//   //work order pAGE -------------02-10 commened----------------
//   // const [workOrderData, setWorkOrderData] = useState([]);
//   // const [workOrderCurrentPage, setWorkOrderCurrentPage] = useState(1);

//   // const workOrdersPerPage = 10;

//   // const totalWorkOrders = Array.isArray(workOrderData)
//   //   ? workOrderData.length
//   //   : 0;

//   // const workOrderTotalPages = Math.ceil(totalWorkOrders / workOrdersPerPage);

//   // const workOrderIndexOfLast = workOrderCurrentPage * workOrdersPerPage;

//   // const workOrderIndexOfFirst = workOrderIndexOfLast - workOrdersPerPage;

//   // const currentWorkOrders = workOrderData.slice(
//   //   workOrderIndexOfFirst,
//   //   workOrderIndexOfLast,
//   // );

//   // ================= HEAD PAGINATION =================
//   const [headCurrentPage, setHeadCurrentPage] = useState(1);
//   const headsPerPage = 8;
//   const headTableData = Object.entries(
//     headFetchedData.reduce((acc, val) => {
//       acc[val.BudgetHead] =
//         (acc[val.BudgetHead] || 0) + (parseFloat(val.EsitmateAmount) || 0);
//       return acc;
//     }, {}),
//   );
//   const headTotalPages = Math.ceil(headTableData.length / headsPerPage);
//   const headIndexOfLast = headCurrentPage * headsPerPage;
//   const headIndexOfFirst = headIndexOfLast - headsPerPage;
//   const currentHeads = headTableData.slice(headIndexOfFirst, headIndexOfLast);

//   const getAgencyWiseData = async () => {
//     console.log("projectId", projectId);
//     // Pick which dataset to show
//     if (!projectId) return; // Don't fetch unless both dates are selected
//     console.log("Fetching data for:", projectId);
//     setloading(true);
//     const data = await GetAgencyWiseData(projectId, "Projectfetching");
//     console.log("Received data:", data);

//     if (data) {
//       setDateData(data);
//       setloading(false);
//     }
//   };

//   console.log("headFetchedData: ", headFetchedData);

//   const GetHeadBugetEstimationTable = async (PID) => {
//     try {
//       let res = await GetProjectInfo(PID, "getprojectHeadEstimationamount");
//       console.log("Head data i am getting :: ", res);
//       // setHeadFetchedData(res);
//       setHeadEstimationData(Array.isArray(res) ? res : []);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   const GetHeadBuget = async () => {
//     try {
//       let res = await GetBudgetHeadInfo("null", "all");
//       setHeadFetchedData(Array.isArray(res) ? res : []);
//       console.log("Head data i am getting :: ", res);
//       // setHeadFetchedData(res);
//     } catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     if (projectId) {
//       GetHeadBugetEstimationTable(projectId);
//       GetHeadBuget(projectId);
//     }
//   }, [projectId]); //remove the headId

//   // This new useEffect is dedicated to fetching the specific amounts
//   // for a single selected head.
//   useEffect(() => {
//     const fetchHeadData = async () => {
//       if (!headId) {
//         alert("headID required");
//         return;
//       }
//       try {
//         // Call your backend with the new type
//         const headData = await GetBudgetHeadInfo(
//           projectId,
//           "getHeadSpecificAmounts",
//           headId,
//         );
//         console.log("Fetched head-specific data:", headData);
//       } catch (err) {
//         console.error(err);
//       }
//     };

//     if (projectId && headId) {
//       fetchHeadData();
//     }
//   }, [projectId, headId]); // Trigger this when projectId or headId changes

//   useEffect(() => {
//     if (projectId === "") {
//       // reset to overall data when "Choose Project" is selected
//       setDateData({});
//       return;
//     }

//     // only fetch project data if a project is actually selected
//     console.log("projectId changed. Triggering data fetch.");
//     getAgencyWiseData();
//     getVendorbill();
//   }, [projectId]);

//   const getDeductionData = async () => {
//     try {
//       console.log(projectId);
//       setloading(true);
//       const data = await GetAgencyWiseData(projectId, "deductionFetching");
//       console.log("Received data:----------------", data);
//       setDeductionData(data);
//     } catch (err) {
//       console.log(err);
//     } finally {
//       setloading(false);
//     }
//   };
//   useEffect(() => {
//     if (projectId) {
//       getDeductionData();
//     }
//   }, [projectId]);

//   const [search, setSearch] = useState("");

//   const displayData = projectId ? dateData : getData;

//   const tableData = projectId
//     ? projectdata.filter((item) => String(item.ProjectId) === String(projectId))
//     : projectdata;
//   console.log("display data --->", displayData);

//   // const filteredProjects = (projectdata || []).filter((p) =>
//   //   p.ProjectName?.toLowerCase().includes(search.trim().toLowerCase())
//   // );

//   const agencyProjects = (projectdata || []).filter(
//     (p) => String(p.PIU).trim() === String(agencyCode).trim(),
//   );

//   const searchedProjects = agencyProjects.filter((p) =>
//     p.ProjectName?.toLowerCase().includes(search.trim().toLowerCase()),
//   );

//   console.log("LOCAL STORAGE");
//   console.log(localStorage);

//   console.log("SESSION STORAGE");
//   console.log(sessionStorage);
//   const handleSchemeChange = (e) => {
//     const selectedScheme = e.target.value;

//     setScheme(selectedScheme);
//     setProjectId("");
//     setheadId("");

//     if (!selectedScheme) {
//       setFilteredProjects(projectdata);
//       return;
//     }

//     const schemeProjects = projectdata.filter((project) => {
//       return project.Scheme === selectedScheme;
//     });

//     const uniqueProjects = Array.from(
//       new Map(
//         schemeProjects.map((project) => [project.ProjectId, project]),
//       ).values(),
//     );

//     setFilteredProjects(uniqueProjects);
//   };

//   const handleHeadChange = (e) => {
//     const selectedHeadId = e.target.value;
//     setheadId(selectedHeadId);
//     setProjectId("");

//     if (!selectedHeadId) {
//       setFilteredProjects(projectdata);
//       return;
//     }
//     const projectsForHead = projectdata.filter(
//       (project) => String(project.HeadID) === String(selectedHeadId),
//     );

//     const uniqueProjects = Array.from(
//       new Map(
//         projectsForHead.map((project) => [project.ProjectId, project]),
//       ).values(),
//     );
//     setFilteredProjects(uniqueProjects);
//     console.log("Selected Head ID:", e.target.value);
//   };

//   const selectedProject = projectdata.find(
//     (p) => String(p.ProjectId) === String(projectId),
//   );

//   //this fetech head according to project 10-08
//   // const filteredHeads = (headFetchedData || []).filter((head) => {
//   //   if (!projectId) return true;

//   //   return String(head.HeadID) === String(selectedProject?.HeadID);
//   // });

//   // Handle project selection
//   const handleProjectChange = (e) => {
//     const selectedProjectId = e.target.value;
//     console.log("PROJECT SELECTED:=-=>", selectedProjectId);
//     setProjectId(selectedProjectId);
//     // setheadId("");
//   };

//   useEffect(() => {
//     console.log("🔴 projectId changed:", projectId);
//   }, [projectId]);

//   useEffect(() => {
//     console.log("🟢 headId changed:", headId);
//   }, [headId]);
//   console.log("PROJECT DATA:", projectdata);

//   const deductionTypeData = {};

//   demandGenerationData.forEach((item) => {
//     const workName = item.ProjectName || "-";

//     // Change this field if your API returns a different deduction-name field
//     const deductionName = item.DeductionName || item.TypeOfAmount || "-";

//     const deductionAmount = Number(item.DeductionAmount || 0);

//     const key = `${workName}_${deductionName}`;

//     if (!deductionTypeData[key]) {
//       deductionTypeData[key] = {
//         WorkName: workName,
//         DeductionName: deductionName,
//         DeductionAmount: 0,
//       };
//     }

//     deductionTypeData[key].DeductionAmount += deductionAmount;
//   });

//   const deductionTypeList = Object.values(deductionTypeData);

//   const totalDeductionAmount = deductionTypeList.reduce(
//     (total, item) => total + Number(item.DeductionAmount || 0),
//     0,
//   );

//   // const totalWorkOrderCount = Array.isArray(workOrderData)
//   //   ? workOrderData.length
//   //   : 0;

//   const totalWorkOrderCount = getData.TotalWorkOrders || 0;

//   const totalReleaseAmount = Array.isArray(releaseAmountData)
//     ? releaseAmountData.reduce(
//         (sum, item) => sum + Number(item.ReleaseAmountTillDate || 0),
//         0,
//       )
//     : 0;

//   const loadDeductionWorkOrders = async () => {
//     try {
//       const data = await GetAgencyDashboardData({
//         agencyCode,
//         projectId: projectId || "",
//         type: "deductionWorkOrder",
//       });
//       setDeductionWorkOrders(Array.isArray(data) ? data : []);
//       setSelectedWorkOrder("");
//       setDeductionDetails([]);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const loadDeductionDetails = async (workOrderUID) => {
//     try {
//       const data = await GetAgencyDashboardData({
//         agencyCode,
//         type: "deductionDetails",
//         workOrderUID,
//       });
//       console.log("RAW deductionDetails:", JSON.stringify(data, null, 2)); // <-- add th
//       setSelectedWorkOrder(workOrderUID);
//       setDeductionDetails(Array.isArray(data) ? data : []);
//     } catch (error) {
//       console.error("Deduction Details Error:", error);
//       setDeductionDetails([]);
//     }
//   };

//   const getPageNumbers = (currentPage, totalPages) => {
//     if (totalPages <= 5) {
//       return Array.from({ length: totalPages }, (_, index) => index + 1);
//     }

//     if (currentPage <= 3) {
//       return [1, 2, 3, 4, "...", totalPages];
//     }

//     if (currentPage >= totalPages - 2) {
//       return [
//         1,
//         "...",
//         totalPages - 3,
//         totalPages - 2,
//         totalPages - 1,
//         totalPages,
//       ];
//     }

//     return [
//       1,
//       "...",
//       currentPage - 1,
//       currentPage,
//       currentPage + 1,
//       "...",
//       totalPages,
//     ];
//   };

//   // ================= COMMON TABLE PAGINATION =================

//   const rowsPerPage = 10;

//   // ============================================================
//   // PROJECT COST PAGINATION 02-10 commneted
//   // ============================================================

//   const [projectCostCurrentPage, setProjectCostCurrentPage] = useState(1);

//   // const projectCostData = Array.isArray(tableData) ? tableData : [];

//   // const projectCostTotalPages = Math.max(
//   //   1,
//   //   Math.ceil(projectCostData.length / rowsPerPage),
//   // );

//   // const projectCostIndexOfFirst = (projectCostCurrentPage - 1) * rowsPerPage;

//   // const projectCostIndexOfLast = projectCostIndexOfFirst + rowsPerPage;

//   // const currentProjectCosts = projectCostData.slice(
//   //   projectCostIndexOfFirst,
//   //   projectCostIndexOfLast,
//   // );

//   // ============================================================
//   // ESTIMATE PAGINATION
//   // ============================================================

//   const [estimateCurrentPage, setEstimateCurrentPage] = useState(1);

//   // const estimateTableData = Array.isArray(estimateData) ? estimateData : []; ----02-10

//   const estimateTableData = filterBySearch(estimateData, [
//   "ProjectID", "ProjectName", "Year", "BudgetHead", "ObjectCode", "EsitmateAmount",
// ]);
 
//   const estimateTotalPages = Math.max(
//     1,
//     Math.ceil(estimateTableData.length / rowsPerPage),
//   );

//   const estimateIndexOfFirst = (estimateCurrentPage - 1) * rowsPerPage;

//   const estimateIndexOfLast = estimateIndexOfFirst + rowsPerPage;

//   const currentEstimates = estimateTableData.slice(
//     estimateIndexOfFirst,
//     estimateIndexOfLast,
//   );

//   // ============================================================
//   // PROGRESS PAGINATION ----------02-10
//   // ============================================================

//   // const [progressCurrentPage, setProgressCurrentPage] = useState(1);

//   // const progressTotalPages = Math.max(
//   //   1,
//   //   Math.ceil(progressData.length / rowsPerPage),
//   // );

//   // const progressIndexOfFirst = (progressCurrentPage - 1) * rowsPerPage;

//   // const progressIndexOfLast = progressIndexOfFirst + rowsPerPage;

//   // const currentProgress = progressData.slice(
//   //   progressIndexOfFirst,
//   //   progressIndexOfLast,
//   // );

//   // ============================================================
//   // RELEASE AMOUNT PAGINATION--02-10
//   // ============================================================

//   // const [releaseAmountCurrentPage, setReleaseAmountCurrentPage] = useState(1);

//   // const releaseAmountTotalPages = Math.max(
//   //   1,
//   //   Math.ceil(releaseAmountData.length / rowsPerPage),
//   // );

//   // const releaseAmountIndexOfFirst =
//   //   (releaseAmountCurrentPage - 1) * rowsPerPage;

//   // const releaseAmountIndexOfLast = releaseAmountIndexOfFirst + rowsPerPage;

//   // const currentReleaseAmounts = releaseAmountData.slice(
//   //   releaseAmountIndexOfFirst,
//   //   releaseAmountIndexOfLast,
//   // );

//   // ============================================================
//   // DEMAND PAGINATION---02-10
//   // ============================================================

//   // const [demandCurrentPage, setDemandCurrentPage] = useState(1);

//   // const demandTotalPages = Math.max(
//   //   1,
//   //   Math.ceil(demandGenerationData.length / rowsPerPage),
//   // );

//   // const demandIndexOfFirst = (demandCurrentPage - 1) * rowsPerPage;

//   // const demandIndexOfLast = demandIndexOfFirst + rowsPerPage;

//   // const currentDemands = demandGenerationData.slice(
//   //   demandIndexOfFirst,
//   //   demandIndexOfLast,
//   // );

//   // ============================================================
//   // DEDUCTION WORK ORDER PAGINATION----------02-10
//   // ============================================================

//   // const [deductionWorkOrderCurrentPage, setDeductionWorkOrderCurrentPage] =
//   //   useState(1);

//   // const deductionWorkOrderTotalPages = Math.max(
//   //   1,
//   //   Math.ceil(deductionWorkOrders.length / rowsPerPage),
//   // );

//   // const deductionWorkOrderIndexOfFirst =
//   //   (deductionWorkOrderCurrentPage - 1) * rowsPerPage;

//   // const deductionWorkOrderIndexOfLast =
//   //   deductionWorkOrderIndexOfFirst + rowsPerPage;

//   // const currentDeductionWorkOrders = deductionWorkOrders.slice(
//   //   deductionWorkOrderIndexOfFirst,
//   //   deductionWorkOrderIndexOfLast,
//   // );

//   // ============================================================
//   // DEDUCTION DETAILS PAGINATION
//   // ============================================================

//   const [deductionDetailsCurrentPage, setDeductionDetailsCurrentPage] =
//     useState(1);

  
// // 23-10 add deduction detail searching functionality
// const filteredDeductionDetails = deductionDetails.filter((item) => {
//   const search = searchText.toLowerCase().trim();

//   return (
//     String(item.DeductionName || "").toLowerCase().includes(search) ||
//     String(item.DeductionAmount || "").toLowerCase().includes(search) ||
//     String(item.ID || "").toLowerCase().includes(search)
//   );
// });

// //  23-10 
// const itemsPerPage = 10;
//   const deductionDetailsIndexOfFirst =
//   (deductionDetailsCurrentPage - 1) * itemsPerPage;

// const deductionDetailsIndexOfLast =
//   deductionDetailsIndexOfFirst + itemsPerPage;

// const currentDeductionDetails = filteredDeductionDetails.slice(
//   deductionDetailsIndexOfFirst,
//   deductionDetailsIndexOfLast
// );

// const deductionDetailsTotalPages = Math.ceil(
//   filteredDeductionDetails.length / itemsPerPage
// );

//   // ============================================================
//   // RESET PAGINATION WHEN DATA CHANGES
//   // ============================================================

//   useEffect(() => {
//     setProjectCostCurrentPage(1);
//   }, [tableData.length, projectId]);

//   useEffect(() => {
//     setEstimateCurrentPage(1);
//   }, [estimateData.length, projectId]);

//   useEffect(() => {
//     setProgressCurrentPage(1);
//   }, [progressData.length, projectId]);

//   useEffect(() => {
//     setReleaseAmountCurrentPage(1);
//   }, [releaseAmountData.length, projectId]);

//   useEffect(() => {
//     setDemandCurrentPage(1);
//   }, [demandGenerationData.length, projectId]);

//   useEffect(() => {
//     setDeductionWorkOrderCurrentPage(1);
//   }, [deductionWorkOrders.length, projectId]);

//   useEffect(() => {
//     setDeductionDetailsCurrentPage(1);
//   }, [deductionDetails.length, projectId]);
//     useEffect(() => {
//     setDeductionDetailsCurrentPage(1);
//   }, [searchText, selectedWorkOrder]);
//   const fetchSpecficUploadPhoto = async (
//   uploadID,
//   WorkOrderNo,
//   physicalWork
// ) => {
//   try {
//     console.log("🔥 UploadID sent:", uploadID);

//     const res = await GetBudgetHeadInfo(
//       uploadID,
//       "GetSpecificUploadImagesfromProgressTable"
//     );

//     console.log("🔥 RAW API RESPONSE:", res);

//     const allImages = Array.isArray(res)
//       ? res
//       : Array.isArray(res?.Data)
//         ? res.Data
//         : [];

//     console.log("🔥 ALL IMAGES:", allImages);

//     const filteredImages = allImages.filter(
//       (image) =>
//         String(image.UploadID).trim() === String(uploadID).trim()
//     );

//     console.log("🔥 MATCHED IMAGES:", filteredImages);

//     setFetchedImages(filteredImages);
//     setSelectedUploadID(uploadID);
//      setCurrentSlide(0); // <-- add this 07-10
//     setShowSpecific(1);

//   } catch (err) {
//     console.error("❌ Image API error:", err);
//   }

// };



// // 02-10
 
//  const [workOrderData, setWorkOrderData] = useState([]);
// const [workOrderCurrentPage, setWorkOrderCurrentPage] = useState(1);
// const workOrdersPerPage = 10;
// const totalWorkOrders = Array.isArray(workOrderData) ? workOrderData.length : 0;
// const filteredWorkOrders = filterBySearch(workOrderData, [
//   "FinancialYear", "ProjectName", "ProjectCost", "CreatedByAgency", "WorkOrderNo",
// ]);
// const workOrderTotalPages = Math.ceil(filteredWorkOrders.length / workOrdersPerPage);
// const workOrderIndexOfLast = workOrderCurrentPage * workOrdersPerPage;
// const workOrderIndexOfFirst = workOrderIndexOfLast - workOrdersPerPage;
// const currentWorkOrders = filteredWorkOrders.slice(
//   workOrderIndexOfFirst,
//   workOrderIndexOfLast,
// );

// const projectCostData = filterBySearch(tableData, [
//   "FinancialYear", "ProjectName", "Agency_Name", "PIU", "ProjectCost", "GRNumber",
// ]);
 

//   const projectCostTotalPages = Math.max(
//     1,
//     Math.ceil(projectCostData.length / rowsPerPage),
//   );
 
//   const projectCostIndexOfFirst = (projectCostCurrentPage - 1) * rowsPerPage;
 
//   const projectCostIndexOfLast = projectCostIndexOfFirst + rowsPerPage;
 
//   const currentProjectCosts = projectCostData.slice(
//     projectCostIndexOfFirst,
//     projectCostIndexOfLast,
//   );

//   const progressTableData = filterBySearch(progressData, [
//   "FinancialYear", "ProjectName", "WorkName", "PhysicalProgress",
// ]);
//  const [progressCurrentPage, setProgressCurrentPage] = useState(1);
 
// const progressTotalPages = Math.max(
//   1,
//   Math.ceil(progressTableData.length / rowsPerPage),
// );
 
 
//   const progressIndexOfFirst = (progressCurrentPage - 1) * rowsPerPage;
 
//   const progressIndexOfLast = progressIndexOfFirst + rowsPerPage;
 
//   const currentProgress = progressTableData.slice(
//   progressIndexOfFirst,
//   progressIndexOfLast,
// );
// const releaseTableData = filterBySearch(releaseAmountData, [
//   "ReleaseID", "FinancialYear", "ProjectName", "ReleaseAmountTillDate",
// ]);
 
//   const [releaseAmountCurrentPage, setReleaseAmountCurrentPage] = useState(1);
 
//   const releaseAmountTotalPages = Math.max(
//     1,
//  Math.ceil(releaseTableData.length / rowsPerPage),
//   );
 
//   const releaseAmountIndexOfFirst =
//     (releaseAmountCurrentPage - 1) * rowsPerPage;
 
//   const releaseAmountIndexOfLast = releaseAmountIndexOfFirst + rowsPerPage;
 
//  const currentReleaseAmounts = releaseTableData.slice(
//   releaseAmountIndexOfFirst,
//   releaseAmountIndexOfLast,
// );
// const demandFilteredData = filterBySearch(demandGenerationData, [
//   "WorkOrderUID", "DemandGenerationID", "RABillNumber", "ContractorName",
//   "BillAmount", "DeductionAmount", "NetPayableAmount",
// ]);
//   const [demandCurrentPage, setDemandCurrentPage] = useState(1);
 
//   const demandTotalPages = Math.max(
//     1,
//    Math.ceil(demandFilteredData.length / rowsPerPage),
//   );
 
//   const demandIndexOfFirst = (demandCurrentPage - 1) * rowsPerPage;
 
//   const demandIndexOfLast = demandIndexOfFirst + rowsPerPage;
 
// const currentDemands = demandFilteredData.slice(
//   demandIndexOfFirst,
//   demandIndexOfLast,
// );

// //  const deductionWorkOrderTableData = filterBySearch(deductionWorkOrders, [
// //   "WorkOrderUID", "ProjectName", "WorkName",
// // ]);
// // 15-10 
// const getDeductionTotal = (item) =>
//   Number(item.TotalDeductionAmount ?? item.DeductionAmount ?? 0);

// const deductionWorkOrderTableData = filterBySearch(
//   deductionWorkOrders.filter((item) => getDeductionTotal(item) > 0),
//   ["WorkOrderUID", "ProjectName", "WorkName"],
// );
// // ---
//   const [deductionWorkOrderCurrentPage, setDeductionWorkOrderCurrentPage] =
//     useState(1);
 
//   const deductionWorkOrderTotalPages = Math.max(
//     1,
//    Math.ceil(deductionWorkOrderTableData.length / rowsPerPage),
//   );
 
//   const deductionWorkOrderIndexOfFirst =
//     (deductionWorkOrderCurrentPage - 1) * rowsPerPage;
 
//   const deductionWorkOrderIndexOfLast =
//     deductionWorkOrderIndexOfFirst + rowsPerPage;
 
//  const currentDeductionWorkOrders = deductionWorkOrderTableData.slice(
//   deductionWorkOrderIndexOfFirst,
//   deductionWorkOrderIndexOfLast,
// );
 
// // 07-10 for img slide
// const parseLocations = (location) => {
//   try {
//     if (Array.isArray(location)) {
//       return location.map((loc) =>
//         typeof loc === "string" ? JSON.parse(loc) : loc,
//       );
//     }
//     const parsed = JSON.parse(location || "[]");
//     return parsed.map((loc) =>
//       typeof loc === "string" ? JSON.parse(loc) : loc,
//     );
//   } catch {
//     return [];
//   }
// };

// const renderPhotoViewer = () => {
//   const cards = [];
//   (FetchedImages || []).forEach((val, index) => {
//     const images = val.Upload
//       ? val.Upload.split(",").map((img) => img.trim())
//       : [];

//     const locations = (() => {
//       try {
//         if (!val.Location) return [];
//         if (
//           typeof val.Location === "string" &&
//           val.Location.includes(",") &&
//           !val.Location.startsWith("[")
//         ) {
//           const [lat, lng] = val.Location.split(",");
//           const dt = val.Date ? new Date(val.Date) : null;
//           return [
//             {
//               latitude: lat?.trim(),
//               longitude: lng?.trim(),
//               date: dt ? dt.toLocaleDateString("en-GB") : "-",
//               time: dt
//                 ? dt.toLocaleTimeString("en-GB", { hour12: false })
//                 : "-",
//               elevation: "",
//               accuracy: "",
//             },
//           ];
//         }
//         return parseLocations(val.Location);
//       } catch {
//         return [];
//       }
//     })();

//     images.forEach((img, imgIndex) => {
//       cards.push({
//         key: `${index}-${imgIndex}`,
//         img,
//         location: locations[imgIndex] || locations[0] || {},
//         progress: val.PhysicalProgress,
//       });
//     });
//   });

//   const total = cards.length;
//   const current = cards[currentSlide] || cards[0];
//   const theme = CARD_THEMES[0];
//   const goPrev = () => setCurrentSlide((p) => (p - 1 + total) % total);
//   const goNext = () => setCurrentSlide((p) => (p + 1) % total);

//   const arrowStyle = (side) => ({
//     position: "absolute",
//     top: "50%",
//     [side]: "10px",
//     transform: "translateY(-50%)",
//     width: "34px",
//     height: "34px",
//     borderRadius: "50%",
//     border: "none",
//     backgroundColor: "rgba(255,255,255,0.92)",
//     boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
//     color: "#333",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     cursor: "pointer",
//     zIndex: 2,
//   });

//   const location = current?.location || {};

//   return (
//     <div
//       className="col-12"
//       style={{
//         backgroundColor: "#fff",
//         height: "88vh",
//         overflowX: "hidden",
//         overflowY: "auto",
//         padding: "20px 24px",
//       }}
//     >
//       <h6
//         className="fw-bold mb-4"
//         style={{ fontSize: "20px", textAlign: "center" }}
//       >
//         Uploaded Id: {selectedUploadId}
//       </h6>

//       {total > 0 ? (
//         <div
//           style={{
//             maxWidth: "380px",
//             margin: "0 auto",
//             border: `1.5px solid ${theme.border}`,
//             borderRadius: "10px",
//             backgroundColor: theme.bg,
//             padding: "10px",
//           }}
//         >
//           {/* Photo slider */}
//           <div
//             style={{
//               position: "relative",
//               width: "100%",
//               height: "240px",
//               borderRadius: "14px",
//               overflow: "hidden",
//               backgroundColor: "#eee",
//             }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 height: "100%",
//                 transform: `translateX(-${currentSlide * 100}%)`,
//                 transition: "transform 0.4s ease",
//               }}
//             >
//               {cards.map((c) => (
//                 <div
//                   key={c.key}
//                   style={{ flex: "0 0 100%", height: "100%", cursor: "pointer" }}
//                   onClick={() =>
//                     setSelectedImage(`${apiurl}/ProgressReport/${c.img}`)
//                   }
//                 >
//                   <img
//                     src={`${apiurl}/ProgressReport/${c.img}`}
//                     alt="Uploaded"
//                     loading="lazy"
//                     decoding="async"
//                     style={{
//                       width: "100%",
//                       height: "100%",
//                       objectFit: "cover",
//                       display: "block",
//                     }}
//                     onError={(e) => {
//                       e.currentTarget.style.display = "none";
//                     }}
//                   />
//                 </div>
//               ))}
//             </div>

//             {total > 1 && (
//               <>
//                 <button type="button" onClick={goPrev} style={arrowStyle("left")} aria-label="Previous">
//                   <FaChevronLeft size={14} />
//                 </button>
//                 <button type="button" onClick={goNext} style={arrowStyle("right")} aria-label="Next">
//                   <FaChevronRight size={14} />
//                 </button>
//                 <span
//                   style={{
//                     position: "absolute",
//                     top: "10px",
//                     right: "10px",
//                     backgroundColor: "rgba(0,0,0,0.55)",
//                     color: "#fff",
//                     fontSize: "11px",
//                     padding: "2px 8px",
//                     borderRadius: "10px",
//                   }}
//                 >
//                   {currentSlide + 1} / {total}
//                 </span>
//               </>
//             )}
//           </div>

//           {/* Dots */}
//           {total > 1 && (
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 gap: "6px",
//                 margin: "10px 0 4px",
//               }}
//             >
//               {cards.map((c, i) => (
//                 <span
//                   key={c.key}
//                   onClick={() => setCurrentSlide(i)}
//                   style={{
//                     width: i === currentSlide ? "18px" : "8px",
//                     height: "8px",
//                     borderRadius: "4px",
//                     backgroundColor: i === currentSlide ? theme.border : "#cfd4dc",
//                     cursor: "pointer",
//                     transition: "all 0.3s",
//                   }}
//                 />
//               ))}
//             </div>
//           )}

//           {/* Info */}
//           <div style={{ marginTop: "12px" }}>
//             <InfoRow theme={theme} icon={<TbLocation />} label="Latitude" value={location.latitude || "-"} />
//             <InfoRow theme={theme} icon={<FaMapMarkerAlt />} label="Longitude" value={location.longitude || "-"} />
//             <InfoRow theme={theme} icon={<FaRegCalendarAlt />} label="Date" value={location.date || "-"} />
//             <InfoRow theme={theme} icon={<FaRegClock />} label="Time" value={location.time || "-"} />
//             <InfoRow theme={theme} icon={<FaMountain />} label="Elevation" value={`${location.elevation && location.elevation !== "-" ? location.elevation : ""} m`} />
//             <InfoRow theme={theme} icon={<FaBullseye />} label="Accuracy" value={`${location.accuracy && location.accuracy !== "-" ? location.accuracy : ""} m`} />
//             <InfoRow theme={theme} icon={<FaChartBar />} label="Work Done" value={`${current?.progress || "-"}%`} />
//           </div>
//         </div>
//       ) : (
//         <div style={{ textAlign: "center", padding: "40px 0", color: "#999" }}>
//           No images found
//         </div>
//       )}

//       <div className="text-center">
//         <button
//           type="button"
//           // 24-10
//           style={{ backgroundColor:"white", border:"1px solid blue"}} className="btn fw-bold px-4 my-3"
//           onClick={() => setShowSpecific(0)}
//         >
//           <img src={"/Back-Arrow-32.jpg"}  alt="Back Icon" className="Back-icon" style={{width:"25px", width:"25px",marginRight:"7px"}} />
//           Back
//         </button>
//       </div>
//     </div>
//   );
// };


// // 13-10
// const handleBack = () => {
//   // Level 3: deduction details -> go back to Deduction Amount Details list
//   if (showTable === "deduction" && selectedWorkOrder !== "") {
//     setSelectedWorkOrder("");
//     setDeductionDetails([]);
//     return;
//   }

//   // Level 2: any table -> go back to dashboard
//   setShowTable(null);
// };


//   return (
//     <> {showSpecific === 1 ? (
//       // <div
//       //   className="col-12"
//       //   style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}
//       // >
//       //   <div className="col-11 m-auto">
//       //     <div className="col-12 PartSection">
//       //       <div className="col-12 py-4">
//       //         <div
//       //           className="col-12"
//       //           style={{
//       //             backgroundColor: "white",
//       //             borderRadius: "8px",
//       //             padding: "20px",
//       //             boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//       //             marginBottom: "20px",
//       //           }}
//       //         >
//       //           <h5 className="text-center fw-bold my-4">
//       //             Upload ID : {selectedUploadId}
//       //           </h5>
    
//       //           <div className="col-10 m-auto ImageContainer">
//       //             <div className="row justify-content-center">
//       //               {FetchedImages && FetchedImages.length > 0 ? (
//       //                 FetchedImages.map((val, index) => {
//       //                   const images = val.Upload
//       //                     ? val.Upload.split(",").map((img) => img.trim())
//       //                     : [];
    
//       //                   const locations = (() => {
//       //                     try {
//       //                       if (!val.Location) return [];
//       //                       if (
//       //                         typeof val.Location === "string" &&
//       //                         val.Location.includes(",") &&
//       //                         !val.Location.startsWith("[")
//       //                       ) {
//       //                         const [lat, lng] = val.Location.split(",");
//       //                         const dt = val.Date ? new Date(val.Date) : null;
//       //                         return [
//       //                           {
//       //                             latitude: lat?.trim(),
//       //                             longitude: lng?.trim(),
//       //                             date: dt ? dt.toLocaleDateString("en-GB") : "-",
//       //                             time: dt
//       //                               ? dt.toLocaleTimeString("en-GB", { hour12: false })
//       //                               : "-",
//       //                             elevation: "-",
//       //                             accuracy: "-",
//       //                           },
//       //                         ];
//       //                       }
//       //                       const parsed = JSON.parse(val.Location || "[]");
//       //                       return parsed.map((loc) =>
//       //                         typeof loc === "string" ? JSON.parse(loc) : loc,
//       //                       );
//       //                     } catch {
//       //                       return [];
//       //                     }
//       //                   })();
    
//       //                   return images.map((img, imgIndex) => {
//       //                     const location = locations[imgIndex] || {};
//       //                     return (
//       //                       <div
//       //                         key={`${index}-${imgIndex}`}
//       //                         className="col-12 col-sm-6 col-md-4 col-lg-3 px-2 my-2"
//       //                       >
//       //                         <div
//       //                           style={{
//       //                             border: "1px solid #ddd",
//       //                             borderRadius: "12px",
//       //                             padding: "10px",
//       //                             background: "#fff",
//       //                           }}
//       //                         >
//       //                           <div
//       //                             style={{
//       //                               width: "100%",
//       //                               height: "220px",
//       //                               borderRadius: "10px",
//       //                               overflow: "hidden",
//       //                               cursor: "pointer",
//       //                               backgroundColor: "#f5f5f5",
//       //                               display: "flex",
//       //                               justifyContent: "center",
//       //                               alignItems: "center",
//       //                             }}
//       //                             onClick={() => {
//       //                               const imageUrl = `${apiurl}/ProgressReport/${img}`;
//       //                               setSelectedImage(imageUrl);
//       //                             }}
//       //                           >
//       //                             <img
//       //                               src={`${apiurl}/ProgressReport/${img}`}
//       //                               alt="Uploaded"
//       //                               loading="lazy"
//       //                               decoding="async"
//       //                               style={{
//       //                                 width: "100%",
//       //                                 height: "100%",
//       //                                 objectFit: "contain",
//       //                                 display: "block",
//       //                               }}
//       //                               onError={(e) => {
//       //                                 e.currentTarget.style.display = "none";
//       //                               }}
//       //                             />
//       //                           </div>
//       //                           <div style={{ marginTop: "10px", fontSize: "13px", lineHeight: "1.6" }}>
//       //                             <div>📍 Latitude: {location.latitude || "-"}</div>
//       //                             <div>📍 Longitude: {location.longitude || "-"}</div>
//       //                             <div>📅 Date: {location.date || "-"}</div>
//       //                             <div>🕒 Time: {location.time || "-"}</div>
//       //                             <div>⛰️ Elevation: {location.elevation || "-"} m</div>
//       //                             <div>🎯 Accuracy: {location.accuracy || "-"} m</div>
//       //                             <div>📊 Physical Done: {val.PhysicalProgress || "-"}%</div>
//       //                           </div>
//       //                         </div>
//       //                       </div>
//       //                     );
//       //                   });
//       //                 })
//       //               ) : (
//       //                 <div style={{ textAlign: "center", padding: "40px 0", color: "#999" }}>
//       //                   No images found
//       //                 </div>
//       //               )}
//       //             </div>
//       //           </div>
    
//       //           <div className="col-12 text-center">
//       //             <button
//       //               type="button"
//       //               className="btn btn-primary fw-bold px-5 my-4"
//       //               onClick={() => setShowSpecific(0)}
//       //             >
//       //               Back
//       //             </button>
//       //           </div>
//       //         </div>
//       //       </div>
//       //     </div>
//       //   </div>
//       // </div>
    
//         // 07-10 for img slide
//    renderPhotoViewer()
//     ) :showTable === null ? (
//         <div
//           style={{
//             background: "white",
//             width: "auto",
//             maxHeight: "92vh",
//             transition: "margin-left 0.3s ease",
//             overflowY: "auto",
//             msOverflowStyle: "none",
//             scrollbarWidth: "none",
//             padding: 20,
//             fontFamily: "Inter, sans-serif",
//           }}
//         >
//           <h5
//             style={{
//               fontWeight: 800,
//               marginLeft: 20,
//               marginBottom: 20,
//               display: "flex",
//               alignItems: "center",
//               gap: 10,
//             }}
//           >
//             <img
//               src={"/Dashboard-Blue-32.png"}
//               alt="Project Icon"
//               style={{ width: 28, height: 28 }}
//             />
//             Project Dashboard
//           </h5>
//           {/* <div style={{ background: '#fff', borderRadius: 12, padding: '20px', marginBottom: 25, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}> */}

//           {/* Select Scheme */}
//           {/* <div className="dropdown-group">
//           <label style={{ fontWeight: 800 }}>Select Scheme:</label>
//           <select name="scheme" value={scheme}
//             onChange={handleSchemeChange}
//             style={{flex: 1,padding: 10, borderRadius: 8,border: "1px solid #ccc"}}>
//             <option value="">Choose Scheme</option>
//             <option value="Budget">Budget</option>
//             <option value="NonBudget">Non Budget</option>
//           </select>
//         </div> */}

//           {/* 
//           { scheme === "Budget"  && (
//           <div className="dropdown-group" >
//             <label style={{ fontWeight: 800 }}>Select Head:</label>
//             <select name="HeadName" value={headId||""}  onChange={handleHeadChange} style={{ flex: 1, padding: 10, borderRadius: 8, border: '1px solid #ccc' }} >
//               <option value="">Choose Head</option> */}
//           {/* {headFetchedData?.map((head, index) => (
//                 <option key={index} value={head.HeadID}>
//                   {head.HeadName || head.BudgetHead}
//                 </option>
//               ))} */}

//           {/* {headFetchedData?.map((head, index) => (
//                   <option key={index} value={head.HeadID}>
//                     {head.HeadName || head.BudgetHead}
//                   </option>
//                 ))}
//             </select>
//           </div>)} */}

//           {/* Select Project */}
//           {canViewProjectSelect && (
//             <div
//               style={{
//                 width: "100%",
//                 minHeight: "94px",
//                 margin: "0 0 14px 0",

//                 backgroundColor: "#eef8ff",
//                 border: "1px solid #b9ddf7",
//                 borderRadius: "10px",
//                 boxSizing: "border-box",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//               }}
//             >
//               <div
//                 className="project-select-row"
//                 // style={{
//                 //   width: "100%",
//                 //   maxWidth: "900px",
//                 //   display: "flex",
//                 //   alignItems: "center",
//                 //   justifyContent: "center",
//                 //   gap: "35px",
//                 //   margin: "0 auto",
//                 //   padding: "0",
//                 //   boxSizing: "border-box",
//                 // }}
//               >
//                 {/* LABEL */}
//                 <label
//                 // style={{
//                 //   flex: "0 0 280px",

//                 //   fontSize: "14px",
//                 //   fontWeight: 700,
//                 //   color: "#111827",
//                 //   lineHeight: "42px",
//                 //   textAlign: "right",
//                 //   whiteSpace: "nowrap",
//                 //   boxSizing: "border-box",
//                 // }}
//                 >
//                   Select Project:
//                 </label>

//                 {/* DROPDOWN */}
//                 <div
//                   className="project-select-box"
//                   // style={{
//                   //   flex: "0 1 420px",
//                   //   width: "420px",
//                   //   minWidth: "300px",
//                   //   margin: "0",
//                   //   padding: "0",
//                   //   boxSizing: "border-box",
//                   // }}
//                 >
//                   <Select
//                     options={searchedProjects.map((p) => ({
//                       value: p.ProjectId,
//                       label: p.ProjectName,
//                     }))}
//                     name="projectId"
//                     value={
//                       searchedProjects
//                         .map((p) => ({
//                           value: p.ProjectId,
//                           label: p.ProjectName,
//                         }))
//                         .find(
//                           (option) =>
//                             String(option.value) === String(projectId),
//                         ) || null
//                     }
//                     onChange={(selectedOption) => {
//                       handleProjectChange({
//                         target: {
//                           name: "projectId",
//                           value: selectedOption ? selectedOption.value : "",
//                         },
//                       });
//                     }}
//                     placeholder="Search / Choose Project"
//                     isSearchable={true}
//                     isClearable={true}
//                     noOptionsMessage={() => "No project found"}
//                     styles={{
//                       /* CONTROL */
//                       control: (base, state) => ({
//                         ...base,
//                         width: "100%",
//                         width: "100%",
//                         minHeight: "40px",
//                         height: "40px",
//                         borderRadius: "8px",
//                         border: state.isFocused
//                           ? "1px solid #0d6efd"
//                           : "1px solid #cfd8e3",
//                         backgroundColor: "#ffffff",
//                         boxShadow: state.isFocused
//                           ? "0 0 0 2px rgba(13, 110, 253, 0.12)"
//                           : "none",
//                         cursor: "pointer",
//                         boxSizing: "border-box",
//                         flexWrap: "nowrap",
//                         // minHeight: "42px",
//                         // height: "42px",
//                         // margin: "0",
//                         // padding: "0",
//                         // borderRadius: "7px",
//                         // border: state.isFocused
//                         //   ? "1px solid #0d6efd"
//                         //   : "1px solid #cfd8e3",
//                         // backgroundColor: "#ffffff",
//                         // boxShadow: state.isFocused
//                         //   ? "0 0 0 2px rgba(13, 110, 253, 0.12)"
//                         //   : "none",
//                         // cursor: "pointer",
//                         // boxSizing: "border-box",
//                       }),

//                       /* VALUE */
//                       valueContainer: (base) => ({
//                         ...base,
//                         height: "40px",
//                         padding: "0 10px",
//                         margin: "0",
//                         boxSizing: "border-box",
//                         display: "flex",
//                         alignItems: "center",
//                         flexWrap: "nowrap",
//                         overflow: "hidden",
//                       }),

//                       /* INPUT */
//                       input: (base) => ({
//                         ...base,
//                         margin: "0",
//                         padding: "0",
//                         fontSize: "14px",
//                         color: "#222",
//                       }),

//                       /* PLACEHOLDER */
//                       placeholder: (base) => ({
//                         ...base,
//                         margin: "0",
//                         color: "#8a8a8a",
//                         fontSize: "14px",
//                         flexWrap: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }),

//                       /* SELECTED VALUE */
//                       singleValue: (base) => ({
//                         ...base,
//                         margin: "0",
//                         color: "#222",
//                         fontSize: "14px",
//                         fontWeight: 500,
//                         flexWrap: "nowrap",
//                         overflow: "visible",
//                         textOverflow: "ellipsis",
//                       }),

//                       /* REMOVE SEPARATOR */
//                       indicatorSeparator: () => ({
//                         display: "none",
//                       }),

//                       menuPortal: (base) => ({
//                         ...base,
//                         zIndex: 999999,
//                       }),

//                       /* DROPDOWN ARROW */
//                       dropdownIndicator: (base) => ({
//                         ...base,
//                         width: "38px",
//                         height: "40px",
//                         padding: "0",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         color: "#777",
//                       }),

//                       /* CLEAR BUTTON */
//                       clearIndicator: (base) => ({
//                         ...base,
//                         width: "30px",
//                         height: "40px",
//                         padding: "0",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }),

//                       /* DROPDOWN MENU */
//                       menu: (base) => ({
//                         ...base,
//                         width: "100%",
//                         marginTop: "4px",
//                         marginBottom: "0",
//                         padding: "0",
//                         borderRadius: "7px",
//                         border: "1px solid #d9dfe7",
//                         backgroundColor: "#ffffff",
//                         boxShadow: "0 6px 15px rgba(0, 0, 0, 0.12)",
//                         overflow: "hidden",
//                         // zIndex: 9999,
//                       }),

//                       /* MENU LIST */
//                       menuList: (base) => ({
//                         ...base,
//                         maxHeight: "220px",
//                         padding: "4px",
//                         margin: "0",
//                         overflowY: "auto",
//                       }),

//                       /* OPTIONS */
//                       option: (base, state) => ({
//                         ...base,
//                         minHeight: "38px",
//                         padding: "9px 12px",
//                         margin: "1px 0",
//                         borderRadius: "5px",
//                         fontSize: "14px",
//                         color: state.isSelected ? "#ffffff" : "#222222",
//                         backgroundColor: state.isSelected
//                           ? "#0d6efd"
//                           : state.isFocused
//                             ? "#eef5ff"
//                             : "#ffffff",
//                         cursor: "pointer",
//                       }),

//                       /* NO OPTIONS */
//                       noOptionsMessage: (base) => ({
//                         ...base,
//                         padding: "12px",
//                         margin: "0",
//                         fontSize: "13px",
//                         color: "#777",
//                         textAlign: "center",
//                       }),
//                     }}
//                     menuPortalTarget={document.body}
//                     menuPosition="fixed"
//                     menuPlacement="bottom"
//                     menuShouldScrollIntoView={false}
//                   />
//                 </div>
//               </div>
//             </div>
//           )}
//           {/* </div> */}
//           {loading ? (
//             <div className="Adminloader"></div>
//           ) : (
//             <>
//               {/* Top Cards */}
//               <div className="dashboard-summary-grids">
//                 <div className="summary-card">
//                   <div className="summary-card-icon">
//                      <img src={"/Total-Project.png"} alt="Total Project Cost" />
//                   </div>
//                   <div className="Agency-summary-card-content">
//                     <h6>Total Project Cost</h6>
//                     <h6 style={{ margin: 0, fontWeight: 600 }}>
//                       ₹{" "}
//                       {Number(displayData?.Project_Cost || 0).toLocaleString(
//                         "en-IN",
//                       )}
//                     </h6>
//                   </div>
//                   <div  className="agency-card-arrow"
//                     onClick={() => setShowTable("projectCost")}
//                     style={{
//                       marginLeft: "auto",
//                       cursor: "pointer",
//                       display: "flex",
//                       alignItems: "center",
//                     }}
//                   >
//                     <img
//                       src="/Arrow64.png"
//                       alt="arrow"
//                       style={{ width: 30, height: 30 }}
//                     />
//                   </div>
//                 </div>
//                 {/* { scheme === "Budget"  && (<div >
//               <div style={{ flex: '2 2 30%', background: '#ffffff', borderRadius: 15, padding: 20, display: 'flex', alignItems: 'center', color: '#000', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
//                 <div >
//                   <img src={TotalHeadsAssigns} style={{ maxWidth: '100%', height: '60px', marginRight: '10px' }} />
//                 </div>
//                   <h6>Total Heads Assigns</h6>
//                   <h6 style={{ margin: 0, fontWeight: 600 }}>₹ {projectId? "1": Number(displayData.BudgetHead || 0).toLocaleString("en-IN")}</h6>
//                 </div>
//               </div>)} */}

//                 {/* {canViewProjectSelect && (
//                 <div className="summary-card">
//                   <div className="summary-card-icon">
//                     <img
//                       src={TotalEsitmateAmount}
//                       style={{
//                         maxWidth: "100%",
//                         height: "60px",
//                         marginRight: "10px",
//                       }}
//                     />
//                   </div>
                  
//                   <div className="summary-card-content">
//                     <h6>Total Estimate Amount</h6>
//                     <h6 style={{ margin: 0, fontWeight: "600" }}>
//                       ₹{" "}
//                       {Number(displayData?.Esitmate_Amount || 0).toLocaleString(
//                         "en-IN",
//                       )}
//                     </h6>
//                   </div>
                   
//                   <div
//                     onClick={() => setShowTable("estimate")}
//                     style={{ marginLeft: "auto", cursor: "pointer" }}
//                   >
//                     <img
//                       src="/Arrow64.png"
//                       alt="arrow"
//                       style={{ width: 30, height: 30 }}
//                     />
//                   </div>
//                 </div>
//  )} */}
//                 {/* Total Progress Report Card */}
//                 <div className="summary-card">
//                   {" "}
//                   <div className="summary-card-icon">
//                     {" "}
//                    <img
//                       src={"/Total-Progress-Report-100.png"}
//                       // replace with your ProgressReport icon if available
//                       style={{ width: 50, height: 50, marginRight: 15 }}
//                       alt="Progress Report"
//                     />{" "}
//                   </div>{" "}
//                   <div className="Agency-summary-card-content">
//                     {" "}
//                     <h5> Total Progress Report </h5>{" "}
//                     <h6>
//                       {/* {" "}
//                                               {projectId
//                                                 ? `${Number(displayData.ProjectProgress || 0).toFixed(0)}%`
//                                                 : "0%"}{" "} */}
//                       {progressData.length}
//                       {/**{Number(displayData.ProjectProgress || 0).toFixed(0)} */}
//                     </h6>
//                   </div>{" "}
//                   <div
//                     onClick={() => setShowTable("progress")}
//                      style={{ marginLeft: "auto", cursor: "pointer" }}
//                      className="agency-card-arrow" 
//                   >
                    
//                     <img src="/Arrow64.png" alt="arrow" />
//                   </div>
//                 </div>

//                 {/* Bottom Small Cards */}

//                 <div className="summary-card">
//                   <div className="summary-card-icon">
//                     <img  src={"/Total-Limit-Allocation.png"}  />
//                   </div>
//                   {/* <div >
//                   <h5 style={{ margin: 0, fontSize: 15 }}>Total Fund Management Allocation</h5>
//                   <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700 }} >₹ {Number(displayData.ReleaseAmountTillDate).toLocaleString("en-IN")}</h3>
//                   {/* <p style={{ margin: '0px' }}><strong style={{ color: '#01b574' }}>+23%</strong> since last month</p> */}
//                   {/* </div>  */}
//                   <div className="Agency-summary-card-content">
//                     <h5 style={{ margin: 0, fontSize: 15 }}>
//                       Total Limit Allocation
//                     </h5>

//                     <h6 style={{ margin: 0, fontSize: 17, fontWeight: 700 }}>
//                       ₹ {totalReleaseAmount.toLocaleString("en-IN")}
//                     </h6>
//                   </div>
//                   <div
//                     onClick={() => setShowTable("releaseamount")}
//                     style={{ marginLeft: "auto", cursor: "pointer" }}
//                      className="agency-card-arrow"
//                   >
//                     <img
//                       src="/Arrow64.png"
//                       alt="arrow"
//                       style={{ width: 30, height: 30 }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div
//                 className="dashboard-bottom-cards"
//                 style={{
//                   width: "100%",
//                   display: "grid",
//                   gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
//                   gap: "12px",
//                   margin: "12px 0 15px 0",
//                   padding: 0,
//                   boxSizing: "border-box",
//                 }}
//               >
//                 {/* =====================================================
//       TOTAL WORK ORDERS
//   ====================================================== */}
//                 <div
//                   style={{
//                     width: "100%",
//                     height: "82px",
//                     minWidth: 0,

//                     display: "flex",
//                     alignItems: "center",

//                     padding: "10px 15px",
//                     boxSizing: "border-box",

//                     backgroundColor: "#f4f9ff",
//                     border: "1px solid #b8d8f5",
//                     borderRadius: "10px",

//                     boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
//                   }}
//                 >
//                   {/* Icon */}
//                   <div className="summary-card-icon">
//                     <img src={"/Total-Work-Orders-100.png"} />
//                   </div>

//                   {/* Content */}
//                   <div
//                     style={{
//                       flex: 1,
//                       minWidth: 0,
//                       overflow: "hidden",
//                     }}
//                   >
//                     <h5
//                       style={{
//                         margin: "0 0 3px 0",
//                         padding: 0,

//                         fontSize: "14px",
//                         lineHeight: "18px",
//                         fontWeight: 600,

//                         color: "#111827",

//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }}
//                     >
//                       Total Work Orders
//                     </h5>

//                     <h3
//                       style={{
//                         margin: 0,
//                         padding: 0,

//                         fontSize: "16px",
//                         lineHeight: "20px",
//                         fontWeight: 700,

//                         color: "#111827",
//                       }}
//                     >
//                       {displayData?.TotalWorkOrders || totalWorkOrders || 0}
//                     </h3>
//                   </div>

//                   {/* Arrow */}
//                   <div  className="agency-card-arrow"
//                     onClick={() => setShowTable("workOrder")}
//                     style={{
//                       flex: "0 0 32px",
//                       width: "32px",
//                       height: "32px",

//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",

//                       marginLeft: "8px",

//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src="/Arrow64.png"
//                       alt="arrow"
//                       style={{
//                         width: "27px",
//                         height: "27px",
//                         objectFit: "contain",
//                       }}
//                     />
//                   </div>
//                 </div>

//                 {/* =====================================================
//       TOTAL DEMAND GENERATIONS
//   ====================================================== */}
//                 <div className="agency-bill-card"
//                   style={{
//                     width: "100%",
//                     height: "82px",
//                     minWidth: 0,

//                     display: "flex",
//                     alignItems: "center",

//                     padding: "10px 15px",
//                     boxSizing: "border-box",

//                     backgroundColor: "#f8f6ff",
//                     border: "1px solid #d7c5ff",
//                     borderRadius: "10px",

//                     boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
//                   }}
//                 >
//                   {/* Icon */}
//                   <div className="summary-card-icon">
//                       <img  src={"/Total-Demand-Generations-100.png"}  alt="Total Bill Generation" />
//                   </div>

//                   {/* Content */}
//                   <div
//                     style={{
//                       flex: 1,
//                       minWidth: 0,
//                       overflow: "hidden",
//                     }}
//                   >
//                     <h5
//                       style={{
//                         margin: "0 0 3px 0",
//                         padding: 0,

//                         fontSize: "14px",
//                         lineHeight: "18px",
//                         fontWeight: 600,

//                         color: "#111827",

//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }}
//                     >
//                       Total Demand Generations
//                     </h5>

//                     <h6
//                       style={{
//                         margin: 0,
//                         padding: 0,

//                         fontSize: "16px",
//                         lineHeight: "20px",
//                         fontWeight: 700,

//                         color: "#111827",
//                       }}
//                     >
//                       ₹{" "}
//                       {Number(displayData?.LiabalityAmount || 0).toLocaleString(
//                         "en-IN",
//                       )}
//                     </h6>
//                   </div>

//                   {/* Arrow */}
//                   <div
//                     className="dashboard-right-card-arrow agency-card-arrow"
//                     onClick={() => setShowTable("demand")}
//                   >
//                     <img src="/Arrow64.png" alt="arrow" />
//                   </div>
//                 </div>

//                 {/* =====================================================
//       TOTAL DEDUCTION AMOUNT
//   ====================================================== */}
//                 <div className="agency-bill-card"
//                   style={{
//                     width: "100%",
//                     height: "82px",
//                     minWidth: 0,

//                     display: "flex",
//                     alignItems: "center",

//                     padding: "10px 15px",
//                     boxSizing: "border-box",

//                     backgroundColor: "#fff8f3",
//                     border: "1px solid #f5d4bd",
//                     borderRadius: "10px",

//                     boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)",
//                   }}
//                 >
//                   {/* Icon */}
//                   <div className="summary-card-icon">
//                       <img   src={"/Total-Deduction-Amount.png"} alt="Total Deduction" />
//                   </div>

//                   {/* Content */}
//                   <div
//                     style={{
//                       flex: 1,
//                       minWidth: 0,
//                       overflow: "hidden",
//                     }}
//                   >
//                     <h5
//                       style={{
//                         margin: "0 0 3px 0",
//                         padding: 0,

//                         fontSize: "14px",
//                         lineHeight: "18px",
//                         fontWeight: 600,

//                         color: "#111827",

//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                       }}
//                     >
//                       Total Deduction Amount
//                     </h5>

//                     <h3
//                       style={{
//                         margin: 0,
//                         padding: 0,

//                         fontSize: "16px",
//                         lineHeight: "20px",
//                         fontWeight: 700,

//                         color: "#111827",
//                       }}
//                     >
//                       ₹{" "}
//                       {Number(
//                         displayData?.TotalDeductionAmount || 0,
//                       ).toLocaleString("en-IN")}
//                     </h3>
//                   </div>

//                   {/* Arrow */}
//                   <div
//                     className="dashboard-card-arrow agency-card-arrow"
//                     onClick={() => {
//                       setShowTable("deduction");
//                       loadDeductionWorkOrders();
//                     }}
//                     style={{
//                       flex: "0 0 32px",
//                       width: "32px",
//                       height: "32px",

//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",

//                       marginLeft: "8px",

//                       cursor: "pointer",
//                     }}
//                   >
//                     <img
//                       src="/Arrow64.png"
//                       alt="arrow"
//                       style={{
//                         width: "27px",
//                         height: "27px",
//                         objectFit: "contain",
//                       }}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* <div className="card mx-3 my-3" style={{ display: 'ruby', alignItems: 'center', width: '20rem', height: '7rem', borderRadius: "15px", background: 'white', backdropFilter: 'blur(52px)', border: 'none' }}>
//               <div style={{ display: 'flex', padding: '20px' }}>
//                 <img src={Earningss} style={{ maxWidth: '100%', height: 'auto' }} />
//               </div>
//               <div>
//                 <h6 style={{ color: 'darkgray' }}>Security Deposite</h6>
//                 <h3 >₹ {dateData.Security_Total !== undefined && dateData.Security_Total !== null ? Number(dateData.Security_Total).toLocaleString("en-IN") : Number(getData.securityDeposite).toLocaleString("en-IN")}</h3>
//               </div>

//             </div> */}

//               {/* <div className="card mx-3 my-3" style={{ display: 'ruby', width: '20rem', height: '7rem', borderRadius: "15px", background: 'white', backdropFilter: 'blur(52px)', border: 'none' }}>
//               <div style={{ display: 'flex', padding: '20px' }}>
//                 <img src={Earningsss} style={{ maxWidth: '100%', height: 'auto' }} />
//               </div>
//               <div style={{ flex: '1 1 auto' }}>
//                 <h6 style={{ margin: '0px', color: 'darkgray' }}>Total Inward Bills</h6>
//                 <h3 style={{ margin: '0px' }}>{dateData.total_bills !== undefined && dateData.total_bills !== null ? dateData.total_bills : getData.TotalBills}</h3>
//               </div>
//             </div>
//             <div className="card mx-3 my-3" style={{ display: 'ruby', width: '20rem', height: '7rem', borderRadius: "15px", background: 'white', backdropFilter: 'blur(52px)', border: 'none' }}>
//               <div style={{ display: 'flex', padding: '20px' }}>
//                 <img src={ECSFile} style={{ maxWidth: '65%', height: 'auto' }} />
//               </div>
//               <div style={{ flex: '1 1 auto' }}>
//                 <h6 style={{ margin: '0px', color: 'darkgray' }}>Total ECS Files</h6>
//                 <h3 style={{ margin: '0px' }}>{dateData.TotalECSfiles !== undefined && dateData.TotalECSfiles !== null ? dateData.TotalECSfiles : getData.TotalECSfiles}</h3>
//               </div>
//             </div> */}
//               {/* <div style={{ display: 'flex', flexWrap: 'wrap', borderRadius: '15px', padding: '10px 25px', gap: '20px', alignItems: 'center', }}>
//                 <div style={{ width: '19rem' }}></div>
//               </div> */}

//               {/* <div className=' ps-5' style={{ display: 'flex', justifyContent: 'start', flexWrap: 'wrap' }}>

//               <div className="card mx-3 my-3" style={{ display: 'ruby', alignItems: 'center', width: '21rem', height: '7rem', borderRadius: "15px", background: 'white', backdropFilter: 'blur(52px)', border: 'none' }}>
//                 <div style={{ display: 'flex', padding: '20px' }}>
//                   <img src={Earnings} />
//                 </div>
//                 <div >
//                   <h6 style={{ color: 'darkgray' }}>Total Deduction Amount</h6>
//                   <h5 style={{ margin: '0px' }}>₹ {Number(displayData.TotalDeductionAmount).toLocaleString("en-IN")}</h5> */}
//               {/* <p style={{ margin: '0px' }}><strong style={{ color: '#01b574' }}>+23%</strong> since last month</p> */}
//               {/* </div> */}
//               {/* </div> */}

//               {/* <div style={{ display: 'flex', flexWrap: 'wrap', borderRadius: '15px', padding: '10px 25px', gap: '20px', alignItems: 'center', }}>
//                 <div style={{ width: '19rem' }}></div>
//               </div>
//             </div> */}

//               {/* <div className='col-12' style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#e2e8f0', padding: '20px', borderRadius: '15px', flexWrap: 'wrap', gap: '10px' }}> */}

//               {/* <div className="col-12">
//                 <div className="row">





//                 </div>
//               </div> */}

//               {/* <div className='col-6' style={{ width: '60%', backgroundColor: 'white', padding: '20px', borderRadius: '15px' }}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <h4 style={{ fontWeight: '600' }}>Weekly Revenue</h4>
//                 <img src={Graph64} />
//               </div>
//               <div style={{ display: 'grid', width: '100%', backgroundColor: 'white', borderRadius: '15px' }}>
//                 <div id="chart">
//                   <ReactApexChart
//                     options={state1.options}
//                     series={state1.series}
//                     type="bar"
//                     height={350}
//                   />
//                 </div>
//                 <div id="html-dist"></div>
//               </div>
//             </div> */}

//               {/* Charts Row */}
//               {/* =========================================================
//     CHARTS ROW
// ========================================================= */}

//               <div
//                 style={{
//                   width: "100%",
//                   display: "grid",
//                   gridTemplateColumns: "minmax(0, 2fr) minmax(280px, 1fr)",
//                   gap: "20px",
//                   margin: 0,
//                   padding: 0,
//                   boxSizing: "border-box",
//                   alignItems: "stretch",
//                 }}
//               >
//                 {/* =====================================================
//       TOTAL SPEND
//   ===================================================== */}
//                 <div
//                   style={{
//                     width: "100%",
//                     minWidth: 0,
//                     backgroundColor: "#ffffff",
//                     border: "1px solid #e8e8e8",
//                     borderRadius: "16px",
//                     boxShadow: "0 4px 15px rgba(0, 0, 0, 0.06)",
//                     overflow: "hidden",
//                     boxSizing: "border-box",
//                   }}
//                 >
//                   {/* HEADER */}
//                   <div
//                     style={{
//                       width: "100%",
//                       height: "58px",
//                       padding: "0 20px",
//                       display: "flex",
//                       alignItems: "center",
//                       borderBottom: "1px solid #eeeeee",
//                       boxSizing: "border-box",
//                     }}
//                   >
//                     <h5
//                       style={{
//                         margin: 0,
//                         fontSize: "16px",
//                         fontWeight: 700,
//                         color: "#222222",
//                       }}
//                     >
//                       Total Spend
//                     </h5>
//                   </div>

//                   {/* CONTENT */}
//                   <div
//                     style={{
//                       width: "100%",
//                       minHeight: "300px",
//                       padding: "20px",
//                       display: "grid",
//                       gridTemplateColumns: "170px minmax(0, 1fr)",
//                       gap: "20px",
//                       alignItems: "center",
//                       boxSizing: "border-box",
//                     }}
//                   >
//                     {/* LEFT SIDE */}
//                     <div
//                       style={{
//                         width: "100%",
//                         display: "flex",
//                         flexDirection: "column",
//                         justifyContent: "center",
//                         gap: "14px",
//                         boxSizing: "border-box",
//                       }}
//                     >
//                       <h1
//                         style={{
//                           margin: 0,
//                           fontSize: "34px",
//                           lineHeight: "1.1",
//                           fontWeight: 700,
//                           color: "#222222",
//                           whiteSpace: "nowrap",
//                         }}
//                       >
//                         ₹37.5K
//                       </h1>

//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "15px",
//                         }}
//                       >
//                         <p
//                           style={{
//                             color: "darkgray",
//                             margin: 0,
//                             fontSize: "13px",
//                             lineHeight: "1.3",
//                           }}
//                         >
//                           Total
//                           <br />
//                           Spend
//                         </p>

//                         <p
//                           style={{
//                             color: "#01b574",
//                             fontWeight: 700,
//                             margin: 0,
//                             fontSize: "13px",
//                           }}
//                         >
//                           +2.45%
//                         </p>
//                       </div>

//                       <h4
//                         style={{
//                           color: "#01b574",
//                           fontWeight: 700,
//                           margin: 0,
//                           fontSize: "15px",
//                         }}
//                       >
//                         On track
//                       </h4>
//                     </div>

//                     {/* RIGHT SIDE GRAPH */}
//                     <div
//                       style={{
//                         width: "100%",
//                         minWidth: 0,
//                         height: "270px",
//                         overflow: "hidden",
//                         boxSizing: "border-box",
//                       }}
//                     >
//                       <ReactApexChart
//                         options={{
//                           ...state.options,

//                           chart: {
//                             ...state.options.chart,
//                             type: "area",
//                             toolbar: {
//                               show: false,
//                             },
//                             parentHeightOffset: 0,
//                             width: "100%",
//                           },

//                           stroke: {
//                             width: [4, 4],
//                             curve: "straight",
//                           },

//                           colors: ["#7f47dd", "#38d1bd"],

//                           fill: {
//                             type: "gradient",

//                             gradient: {
//                               shade: "light",
//                               type: "vertical",
//                               shadeIntensity: 0.4,
//                               gradientToColors: ["#ffffff", "#ffffff"],
//                               inverseColors: false,
//                               opacityFrom: 0.6,
//                               opacityTo: 0,
//                               stops: [0, 100],
//                             },
//                           },

//                           dataLabels: {
//                             enabled: false,
//                           },

//                           grid: {
//                             borderColor: "#e0e0e0",
//                             strokeDashArray: 4,
//                           },

//                           markers: {
//                             size: 4,
//                             colors: ["#ffffff"],
//                             strokeColors: ["#7f47dd", "#38d1bd"],
//                             strokeWidth: 2,
//                           },

//                           legend: {
//                             position: "top",
//                             horizontalAlign: "center",
//                             fontSize: "13px",

//                             labels: {
//                               colors: "#333333",
//                             },
//                           },

//                           responsive: [
//                             {
//                               breakpoint: 768,
//                               options: {
//                                 legend: {
//                                   fontSize: "11px",
//                                 },
//                               },
//                             },
//                           ],
//                         }}
//                         series={state.series}
//                         type="area"
//                         height={270}
//                         width="100%"
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* =====================================================
//       TAXES AND AMOUNTS
//   ===================================================== */}
//                 <div
//                   style={{
//                     width: "100%",
//                     minWidth: 0,
//                     backgroundColor: "#ffffff",
//                     border: "1px solid #e8e8e8",
//                     borderRadius: "16px",
//                     boxShadow: "0 4px 15px rgba(0, 0, 0, 0.06)",
//                     overflow: "hidden",
//                     boxSizing: "border-box",
//                   }}
//                 >
//                   {/* HEADER */}
//                   <div
//                     style={{
//                       width: "100%",
//                       height: "58px",
//                       padding: "0 20px",
//                       display: "flex",
//                       alignItems: "center",
//                       borderBottom: "1px solid #eeeeee",
//                       boxSizing: "border-box",
//                     }}
//                   >
//                     <h5
//                       style={{
//                         margin: 0,
//                         fontSize: "16px",
//                         fontWeight: 700,
//                         color: "#222222",
//                       }}
//                     >
//                       Taxes And Amounts
//                     </h5>
//                   </div>

//                   {/* DONUT CHART */}
//                   <div
//                     style={{
//                       width: "100%",
//                       minHeight: "300px",
//                       padding: "20px",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       boxSizing: "border-box",
//                     }}
//                   >
//                     <div
//                       style={{
//                         width: "100%",
//                         maxWidth: "330px",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       <ReactApexChart
//                         options={
//                           deductionData && deductionData.length > 0
//                             ? state5.options
//                             : state4.options
//                         }
//                         series={
//                           deductionData && deductionData.length > 0
//                             ? state5.series
//                             : state4.series
//                         }
//                         type="donut"
//                         width="100%"
//                         height={250}
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* <tbody>
//               <tr>
//                 <td>Horizon UI PRO</td>
//                 <td style={{ display: 'flex', alignItems: 'center', gap: '1px' }}><img src={Approved32} style={{ width: '14px' }} /> Approved</td>
//                 <td>12 Jan 2021</td>
//                 <td><img src={first} /></td>
//               </tr>
//               <tr>
//                 <td>Horizon UI Free</td>
//                 <td style={{ display: 'flex', alignItems: 'center', gap: '1px' }}><img src={Disable32} style={{ width: '14px' }} /> Disable</td>
//                 <td>21 Feb 2021</td>
//                 <td><img src={Second} /></td>
//               </tr>
//               <tr>
//                 <td>Weekly Update</td>
//                 <td style={{ display: 'flex', alignItems: 'center', gap: '1px' }}><img src={Error32} style={{ width: '14px' }} /> Error</td>
//                 <td>13 Mar 2021</td>
//                 <td><img src={third} /></td>
//               </tr>
//               <tr>
//                 <td>Venus 3D Asset</td>
//                 <td style={{ display: 'flex', alignItems: 'center', gap: '1px' }}><img src={Disable32} style={{ width: '14px' }} /> Disable</td>
//                 <td>24 Jan 2021</td>
//                 <td><img src={forth} /></td>
//               </tr>
//               <tr>
//                 <td>Marketplace</td>
//                 <td style={{ display: 'flex', alignItems: 'center', gap: '1px' }}><img src={Approved32} style={{ width: '14px' }} /> Approved</td>
//                 <td>24 Oct 2022</td>
//                 <td><img src={fifth} /></td>
//               </tr>
//             </tbody> */}
//               <div className="dashboard-tables-grid">
//                 {/* --- Vendor Bills --- */}
//                 <div className="dashboard-card vendor-card">
//                   <div className="dashboard-card-header">
//                     <h4 style={{ fontWeight: "500" }}>Vendor Bills</h4>
//                     {/* <a href="#">View All</a> */}
//                     {/* <img src={MoreMenu64} /> */}
//                   </div>

//                   <div className="vendor-table-container">
//                     <table className="custom-table">
//                       <thead>
//                         <tr>
//                           <th style={{textAlign:"center"}}>Bill Number</th>
//                           <th style={{textAlign:"center"}}>Name</th>
//                           <th style={{textAlign:"center"}}>Status</th>
//                           <th style={{textAlign:"center"}}>Date</th>
//                           <th style={{textAlign:"center"}}> Progress</th>
//                           {/* <th style={{position: "sticky",top: 0,background: "#fff", zIndex: 10, }}>Actions</th> */}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {currentBills.length < 1 ? (
//                           <tr>
//                             {/* <td colSpan="6" style={{ textAlign: "center" }}>
//                               No Bills Found
//                             </td> */}
//                           </tr>
//                         ) : (
//                           currentBills.map((bill, index) => (
//                             <tr key={index}>
//                               <td>{bill.BillNumber}</td>
//                               <td>{bill.Vendor_Company_Name}</td>
//                               <td
//                                 style={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: "6px",
//                                 }}
//                               >
//                                 <img
//                                   src={
//                                     bill.Status === "Sent to Bank" ||
//                                     bill.Status === "Successful/Paid"
//                                       ? Approved32
//                                       : Disable32
//                                   }
//                                   alt=""
//                                   style={{
//                                     width: "16px",
//                                     height: "16px",
//                                     objectFit: "contain",
//                                   }}
//                                 />
//                                 {bill.Status === "false"
//                                   ? "Approvals Pending"
//                                   : bill.Status}
//                               </td>
//                               <td>{bill.UploadedOn?.slice(0, 10)}</td>
//                               <td>
//                                 <div className="progress-bar">
//                                   <div
//                                     className="progress"
//                                     style={{ width: "50%" }}
//                                   ></div>
//                                 </div>
//                               </td>
//                               {/* <td>
//                               <img src={EditIcon} alt="edit" className="action-icon" />
//                               <img src={DeleteIcon} alt="delete" className="action-icon" />
//                             </td> */}
//                             </tr>
//                           ))
//                         )}
//                       </tbody>
//                     </table>
//                     {/* 05-10 */}
//                     {currentBills.length < 1 && (
//   <div
//     style={{
//       position: "sticky",
//       left: 0,
//       width: "100%",
//       textAlign: "center",
//       padding: "20px 15px",
//       color: "#777",
//       fontSize: "14px",
//       boxSizing: "border-box",
//       marginBottom:"30px"
//     }}
//   >
//     No Bills Found
//   </div>
// )}
 
//                   </div>

//                   {/* Vendor Bills Pagination */}
//                   <div
//                     style={{
//                       width: "100%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       marginTop: "15px",
//                       padding: "10px 0",
//                     }}
//                   >
//                     {/* Showing Entries */}
//                     <p
//                       style={{
//                         margin: 0,
//                         fontSize: "13px",
//                         color: "#333",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       {/* Showing{" "}
//                    {vendorbills.length === 0
//                      ? 0
//                      : indexOfFirstBill + 1}{" "}
//                    to{" "}
//                    {Math.min(
//                      indexOfLastBill,
//                      vendorbills.length
//                    )}{" "}
//                    of {vendorbills.length} entries
//                  </p> */}
//                     </p>
//                     {/* Pagination */}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "18px",
//                       }}
//                     >
//                       {/* Previous */}
//                       <button
//                         onClick={() =>
//                           setVendorCurrentPage((prev) => Math.max(prev - 1, 1))
//                         }
//                         disabled={vendorCurrentPage === 1}
//                         style={{
//                           border: "none",
//                           background: "transparent",
//                           color: "#2ea4e7",
//                           cursor:
//                             vendorCurrentPage === 1 ? "not-allowed" : "pointer",
//                           fontSize: "12px",
//                           padding: 0,
//                           opacity: vendorCurrentPage === 1 ? 0.5 : 1,
//                         }}
//                       >
//                         ‹ Previous
//                       </button>
//                       {/* Page Numbers */}
//                       {/* Page Numbers */}
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "20px",
//                         }}
//                       >
//                         {getPageNumbers(
//                           vendorCurrentPage,
//                           vendorTotalPages,
//                         ).map((pageNumber, index) =>
//                           pageNumber === "..." ? (
//                             <span
//                               key={`vendor-ellipsis-${index}`}
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#444",
//                               }}
//                             >
//                               ...
//                             </span>
//                           ) : (
//                             <button
//                               key={pageNumber}
//                               onClick={() => setVendorCurrentPage(pageNumber)}
//                               style={{
//                                 border: "none",
//                                 background: "transparent",
//                                 padding: 0,
//                                 color:
//                                   vendorCurrentPage === pageNumber
//                                     ? "#2ea4e7"
//                                     : "#444",
//                                 cursor: "pointer",
//                                 fontSize: "13px",
//                                 fontWeight:
//                                   vendorCurrentPage === pageNumber
//                                     ? "600"
//                                     : "400",
//                                 textDecoration:
//                                   vendorCurrentPage === pageNumber
//                                     ? "underline"
//                                     : "none",
//                               }}
//                             >
//                               {pageNumber}
//                             </button>
//                           ),
//                         )}
//                       </div>

//                       {/* Next */}
//                       <button
//                         onClick={() =>
//                           setVendorCurrentPage((prev) =>
//                             Math.min(prev + 1, vendorTotalPages),
//                           )
//                         }
//                         disabled={
//                           vendorCurrentPage === vendorTotalPages ||
//                           vendorTotalPages === 0
//                         }
//                         style={{
//                           border: "none",
//                           background: "transparent",
//                           color: "#2ea4e7",
//                           cursor:
//                             vendorCurrentPage === vendorTotalPages ||
//                             vendorTotalPages === 0
//                               ? "not-allowed"
//                               : "pointer",
//                           opacity:
//                             vendorCurrentPage === vendorTotalPages ||
//                             vendorTotalPages === 0
//                               ? 0.5
//                               : 1,
//                           fontSize: "12px",
//                           padding: 0,
//                         }}
//                       >
//                         Next ›
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 {/* --- Head Details --- */}
//                 <div className="dashboard-card head-card">
//                   <div className="dashboard-card-header">
//                     <h4 style={{ fontWeight: "500" }}>Head Details</h4>
//                     {/* <a href="#">View All</a> */}
//                     {/* <img src={MoreMenu64} /> */}
//                   </div>

//                   <div className="table-container">
//                     <table className="head-table">
//                       <thead>
//                         <tr>
//                           <th style={{ width: "60px" }}>Sr. No</th>
//                           <th>Budget Head</th>
//                           <th>Amount</th>
//                           {/* <th>Actions</th> */}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {currentHeads.length > 0 ? (
//                           // Object.entries(
//                           //   headFetchedData.reduce((acc, val) => {
//                           //     acc[val.BudgetHead] = (acc[val.BudgetHead] || 0) + (parseFloat(val.EsitmateAmount) || 0);
//                           //     return acc;
//                           //   }, {})
//                           // )
//                           currentHeads.map(
//                             ([budgetHead, totalAmount], index) => (
//                               <tr key={index}>
//                                 <td>{headIndexOfFirst + 1}</td>
//                                 <td>{headId}</td>
//                                 {/* <td>{budgetHead}</td> */}
//                                 <td>₹ {totalAmount.toLocaleString("en-IN")}</td>
//                                 {/* <td>
//                               <img src={EditIcon} alt="edit" className="action-icon" />
//                               <img src={DeleteIcon} alt="delete" className="action-icon" />
//                             </td> */}
//                               </tr>
//                             ),
//                           )
//                         ) : (
//                           <tr>
//                             <td colSpan="4" style={{ textAlign: "center" }}>
//                               No Data Found
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                   {/* Head Details Pagination */}
//                   <div
//                     style={{
//                       width: "100%",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "space-between",
//                       marginTop: "15px",
//                       padding: "10px 0",
//                     }}
//                   >
//                     {/* Showing Entries */}
//                     <p
//                       style={{
//                         margin: 0,
//                         fontSize: "13px",
//                         color: "#333",
//                         whiteSpace: "nowrap",
//                       }}
//                     >
//                       {/* Showing{" "}
//     {groupedHeadData.length === 0
//       ? 0
//       : headIndexOfFirst + 1}{" "}
//     to{" "}
//     {Math.min(
//       headIndexOfLast,
//       groupedHeadData.length
//     )}{" "}
//     of {groupedHeadData.length} entries */}
//                     </p>

//                     {/* Pagination */}
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "18px",
//                       }}
//                     >
//                       {/* Previous */}
//                       <button
//                         onClick={() =>
//                           setHeadCurrentPage((prev) => Math.max(prev - 1, 1))
//                         }
//                         disabled={headCurrentPage === 1}
//                         style={{
//                           border: "none",
//                           background: "transparent",
//                           color: "#2ea4e7",
//                           cursor:
//                             headCurrentPage === 1 ? "not-allowed" : "pointer",
//                           fontSize: "12px",
//                           padding: 0,
//                           opacity: headCurrentPage === 1 ? 0.5 : 1,
//                         }}
//                       >
//                         ‹ Previous
//                       </button>

//                       {/* Page Numbers */}
//                       <div
//                         style={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "20px",
//                         }}
//                       >
//                         {getPageNumbers(headCurrentPage, headTotalPages).map(
//                           (pageNumber, index) =>
//                             pageNumber === "..." ? (
//                               <span
//                                 key={`head-ellipsis-${index}`}
//                                 style={{
//                                   fontSize: "13px",
//                                   color: "#444",
//                                 }}
//                               >
//                                 ...
//                               </span>
//                             ) : (
//                               <button
//                                 key={pageNumber}
//                                 onClick={() => setHeadCurrentPage(pageNumber)}
//                                 style={{
//                                   border: "none",
//                                   background: "transparent",
//                                   padding: 0,
//                                   color:
//                                     headCurrentPage === pageNumber
//                                       ? "#2ea4e7"
//                                       : "#444",
//                                   cursor: "pointer",
//                                   fontSize: "13px",
//                                   fontWeight:
//                                     headCurrentPage === pageNumber
//                                       ? "600"
//                                       : "400",
//                                   textDecoration:
//                                     headCurrentPage === pageNumber
//                                       ? "underline"
//                                       : "none",
//                                 }}
//                               >
//                                 {pageNumber}
//                               </button>
//                             ),
//                         )}
//                       </div>

//                       {/* Next */}
//                       <button
//                         onClick={() =>
//                           setHeadCurrentPage((prev) =>
//                             Math.min(prev + 1, headTotalPages),
//                           )
//                         }
//                         disabled={
//                           headCurrentPage === headTotalPages ||
//                           headTotalPages === 0
//                         }
//                         style={{
//                           border: "none",
//                           background: "transparent",
//                           color: "#2ea4e7",
//                           cursor:
//                             headCurrentPage === headTotalPages ||
//                             headTotalPages === 0
//                               ? "not-allowed"
//                               : "pointer",
//                           opacity:
//                             headCurrentPage === headTotalPages ||
//                             headTotalPages === 0
//                               ? 0.5
//                               : 1,
//                           fontSize: "12px",
//                           padding: 0,
//                         }}
//                       >
//                         Next ›
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Pagination Controls */}
//               {/* <div style={{ display: 'flex', justifyContent: 'space-evenly', margin: '10px 0' }}>
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
//                 disabled={currentPage === 1}
//                 style={{ padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === 1 ? '#ccc' : 'blue', color: 'white' }}
//               >
//                 Previous
//               </button>
//               <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                 onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
//                 disabled={currentPage === totalPages}
//                 style={{ padding: '6px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === totalPages ? '#ccc' : 'blue', color: 'white' }}
//               >
//                 Next
//               </button>
//             </div> */}
//               {/* </div>  */}
//               {/* <div className='col-6' style={{ display: 'flex', borderRadius: '15px', gap: '20px', }}>
//               <div className='col-6' style={{ backgroundColor: 'white', padding: '20px', borderRadius: '15px', width: '100%' }}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                   <div>
//                     <p style={{ margin: '0px', color: 'darkgray' }}>Daily Traffic</p>
//                     <p style={{ margin: '0px', color: 'darkgray' }}><strong style={{ fontWeight: '800', fontSize: '28px', margin: '0px', color: 'black' }}>2.579</strong> Visitors</p>
//                   </div>
//                   <h5 style={{ color: '#01b574' }}>+2.45%</h5>
//                 </div>
//                 <div id="chart">
//                   <ReactApexChart options={state.options} series={state.series} type="bar" height={380} />
//                 </div>
//                 <div id="html-dist"></div>
//               </div>
//             </div> */}
//             </>
//           )}
//         </div>
//       ) : (
//         <div
//           className="project-details-card"
//           style={{
//             background: "#fff",
//             // padding: 25,
//             borderRadius: 15,
//             // margin: 20,
//             width: "100%",
//             maxWidth: "100%",
//           }}
//         >
//           {/* HEADER */}
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               gap: 12,
//               marginBottom: 20,
//             }}
//           >
//             <button
//               // onClick={() => setShowTable(null)}
//               // 13-10
//               type="button"
//   onClick={handleBack}
//               style={{
//                 border: "none",
//                 background: "transparent",
//                 cursor: "pointer",
//               }}
//             >
//               <img
//                 src="/Back-Arrow-32.jpg"
//                 alt="Back"
//                 style={{
//                   width: 32,
//                 }}
//               />
//             </button>

//             <h4
//               style={{
//                 margin: 0,
//                 fontWeight: 700,
//               }}
//             >
          
//               {showTable === "projectCost" && "Project Cost Details"}

//               {showTable === "estimate" && "Estimate Amount Details"}

//               {showTable === "progress" && "Progress Report Details"}
              
//               {showTable === "releaseamount" && "Limit Allocation Details"}

//               {showTable === "workOrder" && "Work Order Details"}

//               {showTable === "demand" && "Demand Generation Details"}

//               {showTable === "deduction" && "Deduction Amount Details"}
//             </h4>
//                 {/* 02-10 */}
//                <div className="search-container" style={{ marginLeft: "auto" }}>
//   <img
//     src="/Search-32.png"
//     alt="Search Icon"
//     className="search-icon"
//   />
 
//   <input
//     type="text"
//     className="search-input"
//     placeholder="Search..."
//     value={searchText}
//     onChange={(e) => setSearchText(e.target.value)}
//   />
// </div>
//           </div>

//           {/* =================================================
//             PROJECT COST
//         ================================================= */}

//           {showTable === "projectCost" && (
//             <div className="table-responsive" style={{ width: "100%" }}>
//                <div className="table-vscroll">
//               <table className="custom-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "60px" }}>Sr No</th>
//                     <th>Financial Year</th>
//                     <th>Project Name</th>
//                     <th>Implementing Agency</th>
//                     <th>Project Cost</th>
//                     <th>GR Number</th>
//                     <th>GR Date</th>
//                     <th>Creation Date</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {currentProjectCosts.length > 0 ? (
//                     currentProjectCosts.map((project, index) => (
//                       <tr key={project.ProjectId || index}>
//                         <td>{projectCostIndexOfFirst + index + 1}</td>

//                         <td>{project.FinancialYear || "-"}</td>

//                         <td>{project.ProjectName || "-"}</td>

//                         <td>{project.Agency_Name || project.PIU || "-"}</td>

//                         <td>₹ {fmt(project.ProjectCost)}</td>

//                         <td>{project.GRNumber || "-"}</td>

//                         <td>
//                           {project.GRDate
//                             ? new Date(project.GRDate).toLocaleDateString(
//                                 "en-IN",
//                               )
//                             : "-"}
//                         </td>

//                         <td>
//                           {project.Date
//                             ? new Date(project.Date).toLocaleDateString("en-IN")
//                             : "-"}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="8" style={{ textAlign: "center" }}>
//                         No Project Cost Data Found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
// </div>
//               {/* PROJECT COST PAGINATION */}
//               {projectCostData.length > 0 && (
//                 <div className="project-pagination">
//                   <div className="project-pagination-info">
//                     Showing {projectCostIndexOfFirst + 1} to{" "}
//                     {Math.min(projectCostIndexOfLast, projectCostData.length)}{" "}
//                     of {projectCostData.length} entries
//                   </div>

//                   <div className="project-pagination-controls">
//                     {/* PREVIOUS */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setProjectCostCurrentPage((prev) =>
//                           Math.max(prev - 1, 1),
//                         )
//                       }
//                       disabled={projectCostCurrentPage === 1}
//                     >
//                       ‹ Previous
//                     </button>

//                     {/* PAGE NUMBERS */}
//                     <div className="project-page-numbers">
//                       {getPageNumbers(
//                         projectCostCurrentPage,
//                         projectCostTotalPages,
//                       ).map((pageNumber, index) =>
//                         pageNumber === "..." ? (
//                           <span key={`projectcost-dots-${index}`}>...</span>
//                         ) : (
//                           <button
//                             type="button"
//                             key={`projectcost-page-${pageNumber}`}
//                             className={
//                               projectCostCurrentPage === pageNumber
//                                 ? "active"
//                                 : ""
//                             }
//                             onClick={() =>
//                               setProjectCostCurrentPage(pageNumber)
//                             }
//                           >
//                             {pageNumber}
//                           </button>
//                         ),
//                       )}
//                     </div>

//                     {/* NEXT */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setProjectCostCurrentPage((prev) =>
//                           Math.min(prev + 1, projectCostTotalPages),
//                         )
//                       }
//                       disabled={projectCostCurrentPage >= projectCostTotalPages}
//                     >
//                       Next ›
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}
//           {/* =================================================
//             ESTIMATE
//         ================================================= */}

//           {showTable === "estimate" && (
//             <div className="table-responsive" style={{ width: "100%" }}>
//               <div className="table-vscroll">
//               <table className="custom-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "60px" }}>Sr. No</th>
//                     <th>Project ID</th>
//                     <th>Project Name</th>
//                     <th>Financial Year</th>
//                     <th>Budget Head</th>
//                     <th>Object Code</th>
//                     <th>Estimate Amount</th>
//                     <th>Creation Date</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {currentEstimates.length > 0 ? (
//                     currentEstimates.map((item, index) => (
//                       <tr key={item.ID || index}>
//                         <td>{estimateIndexOfFirst + index + 1}</td>

//                         <td>{item.ProjectID || "-"}</td>

//                         <td>{item.ProjectName || "-"}</td>

//                         <td>{item.Year || "-"}</td>

//                         <td>{item.BudgetHead || "-"}</td>

//                         <td>{item.ObjectCode || "-"}</td>

//                         <td>
//                           ₹{" "}
//                           {Number(item.EsitmateAmount || 0).toLocaleString(
//                             "en-IN",
//                           )}
//                         </td>

//                         <td>
//                           {item.Date
//                             ? new Date(item.Date).toLocaleDateString("en-IN")
//                             : "-"}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="8" style={{ textAlign: "center" }}>
//                         No estimate found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
// </div>
//               {/* ================= ESTIMATE PAGINATION ================= */}
//               {estimateTableData.length > 0 && (
//                 <div className="project-pagination">
//                   {/* PAGINATION INFO */}
//                   <div className="project-pagination-info">
//                     Showing {estimateIndexOfFirst + 1} to{" "}
//                     {Math.min(estimateIndexOfLast, estimateTableData.length)} of{" "}
//                     {estimateTableData.length} entries
//                   </div>

//                   <div className="project-pagination-controls">
//                     {/* PREVIOUS */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setEstimateCurrentPage((prev) => Math.max(prev - 1, 1))
//                       }
//                       disabled={estimateCurrentPage === 1}
//                     >
//                       ‹ Previous
//                     </button>

//                     {/* PAGE NUMBERS */}
//                     <div className="project-page-numbers">
//                       {getPageNumbers(
//                         estimateCurrentPage,
//                         estimateTotalPages,
//                       ).map((pageNumber, index) =>
//                         pageNumber === "..." ? (
//                           <span key={`estimate-dots-${index}`}>...</span>
//                         ) : (
//                           <button
//                             type="button"
//                             key={`estimate-page-${pageNumber}`}
//                             className={
//                               estimateCurrentPage === pageNumber ? "active" : ""
//                             }
//                             onClick={() => setEstimateCurrentPage(pageNumber)}
//                           >
//                             {pageNumber}
//                           </button>
//                         ),
//                       )}
//                     </div>

//                     {/* NEXT */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setEstimateCurrentPage((prev) =>
//                           Math.min(prev + 1, estimateTotalPages),
//                         )
//                       }
//                       disabled={estimateCurrentPage >= estimateTotalPages}
//                     >
//                       Next ›
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* =================================================
//             PROGRESS
//         ================================================= */}

//           {showTable === "progress" && (
//             <div className="table-responsive">
//               {" "}
//               {console.log(
//                 "TABLE DATA =>",
//                 progressData,
//                 progressData.length,
//               )}{" "}
//                 <div className="table-vscroll">
//               <table className="custom-table">
//                 {" "}
//                 <thead>
//                   {" "}
//                   <tr>
//                     {" "}
//                     <th style={{ width: "60px" }}>SR No</th>{" "}
//                     <th>Financial Year</th> <th>Project Name</th>{" "}
//                     <th>Work Name</th> <th>Physical Progress %</th>{" "}
//                     <th>Creation Date</th>{" "}
//                   </tr>{" "}
//                 </thead>{" "}
//                 <tbody>
//                   {currentProgress.length > 0 ? (
//                     currentProgress.map((item, index) => (
//                       <tr key={item.ID || index}>
//                         <td>{progressIndexOfFirst + index + 1}</td>
//                         <td>{item.FinancialYear || "-"}</td>
//                         <td>{item.ProjectName || "-"}</td>
//                         <td>{item.WorkName || "-"}</td>
//                         <td>
//                           {/* {item.PhysicalProgress !== undefined &&
//                           item.PhysicalProgress !== null
//                             ? `${item.PhysicalProgress}%`
//                             : "-"} */}
//                                                <button
//   className="btn btn-success px-3"
//   onClick={() => {
//     console.log("Clicked Progress ID:",  item.UploadID,);

//     fetchSpecficUploadPhoto(
//        item.UploadID, // Progress ID = 83, use as UploadID
//       item.WorkOrderNo,
//       item.PhysicalProgress
//     );
//   }}
//   style={{
//     fontSize: "12px",
//     background:
//       "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//     color: "white",
//     border: "none",
//     padding: "6px 12px",
//     borderRadius: "8px",
//     display: "inline-flex",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: "4px",
//     whiteSpace: "nowrap",
//     marginLeft:"10px"
//   }}
// >
//   View Photos
// </button>
//                         </td>
//                         <td>
//                           {item.CreationDate
//                             ? new Date(item.CreationDate).toLocaleDateString(
//                                 "en-IN",
//                               )
//                             : "-"}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="6" style={{ textAlign: "center" }}>
//                         No progress report found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>{" "}
//               </div>
//               {/* PROGRESS PAGINATION */}
//               {progressData.length > 0 && (
//                 <div className="project-pagination">
//                   <div className="project-pagination-info">
//                     Showing {progressIndexOfFirst + 1} to{" "}
//                     {Math.min(progressIndexOfLast, progressData.length)} of{" "}
//                     {progressData.length} entries
//                   </div>

//                   <div className="project-pagination-controls">
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setProgressCurrentPage((prev) => Math.max(prev - 1, 1))
//                       }
//                       disabled={progressCurrentPage === 1}
//                     >
//                       ‹ Previous
//                     </button>

//                     <div className="project-page-numbers">
//                       {getPageNumbers(
//                         progressCurrentPage,
//                         progressTotalPages,
//                       ).map((pageNumber, index) =>
//                         pageNumber === "..." ? (
//                           <span key={`progress-dots-${index}`}>...</span>
//                         ) : (
//                           <button
//                             type="button"
//                             key={`progress-page-${pageNumber}`}
//                             className={
//                               progressCurrentPage === pageNumber ? "active" : ""
//                             }
//                             onClick={() => setProgressCurrentPage(pageNumber)}
//                           >
//                             {pageNumber}
//                           </button>
//                         ),
//                       )}
//                     </div>

//                     <button
//                       type="button"
//                       onClick={() =>
//                         setProgressCurrentPage((prev) =>
//                           Math.min(prev + 1, progressTotalPages),
//                         )
//                       }
//                       disabled={progressCurrentPage >= progressTotalPages}
//                     >
//                       Next ›
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* =================================================
//             WORK ORDER
//         ================================================= */}
//           {showTable === "workOrder" && (
//             <div className="table-responsive">
//                 <div className="table-vscroll">
//               <table className="custom-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "60px" }}>Sr No</th>
//                     <th>Financial Year</th>
//                     <th>Project Name</th>
//                     <th>Project Cost</th>
//                     <th>Agency Name</th>
//                     <th>Work Order Number</th>
//                     <th>Work Creation Date</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {/* {workOrderData && workOrderData.length > 0 ? ( */}
//                    {currentWorkOrders.length > 0 ? ( //07-10
//                     currentWorkOrders.map((item, index) => (
//                       <tr key={item.ID || index}>
//                         <td>{workOrderIndexOfFirst + index + 1}</td>

//                         <td>{item.FinancialYear || "-"}</td>

//                         <td>{item.ProjectName || "-"}</td>

//                         <td>{fmt(item.ProjectCost)}</td>

//                         <td>{item.CreatedByAgency || "-"}</td>

//                         <td>{item.WorkOrderNo || "-"}</td>

//                         <td>
//                           {item.WorkOrderDate
//                             ? new Date(item.WorkOrderDate).toLocaleDateString(
//                                 "en-IN",
//                               )
//                             : "-"}
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan="7"
//                         style={{
//                           textAlign: "center",
//                           padding: "20px",
//                         }}
//                       >
//                         No Work Order Data Found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table></div>
//               {workOrderTotalPages >= 1 && (
//                 <div className="project-pagination">
//                   <div className="project-pagination-info">
//                     Showing {workOrderIndexOfFirst + 1} to{" "}
//                     {Math.min(workOrderIndexOfLast, workOrderData.length)} of{" "}
//                     {workOrderData.length} entries
//                   </div>

//                   <div className="project-pagination-controls">
//                     <button
//                       onClick={() =>
//                         setWorkOrderCurrentPage((prev) => Math.max(prev - 1, 1))
//                       }
//                       disabled={workOrderCurrentPage === 1}
//                     >
//                       ‹ Previous
//                     </button>

//                     <div className="project-page-numbers">
//                       {getPageNumbers(
//                         workOrderCurrentPage,
//                         workOrderTotalPages,
//                       ).map((pageNumber, index) =>
//                         pageNumber === "..." ? (
//                           <span key={`workorder-dots-${index}`}>...</span>
//                         ) : (
//                           <button
//                             key={pageNumber}
//                             className={
//                               workOrderCurrentPage === pageNumber
//                                 ? "active"
//                                 : ""
//                             }
//                             onClick={() => setWorkOrderCurrentPage(pageNumber)}
//                           >
//                             {pageNumber}
//                           </button>
//                         ),
//                       )}
//                     </div>

//                     <button
//                       onClick={() =>
//                         setWorkOrderCurrentPage((prev) =>
//                           Math.min(prev + 1, workOrderTotalPages),
//                         )
//                       }
//                       disabled={workOrderCurrentPage >= workOrderTotalPages}
//                     >
//                       Next ›
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* =================================================
//             DEMAND
//         ================================================= */}

//           {showTable === "demand" && (
//             <div className="table-responsive" style={{ width: "100%" }}>
//               <div className="table-vscroll">
//               <table className="custom-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "60px" }}>Sr. No</th>
//                     <th>Bill UID</th>
//                     <th>RA Bill Number</th>
//                     <th>Contractor Name</th>
//                     <th>Bill Amount</th>
//                     <th>Deduction Amount</th>
//                     <th>Payable Amount</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {currentDemands.length > 0 ? (
//                     currentDemands.map((item, index) => (
//                       <tr key={item.ID || index}>
//                         <td>{demandIndexOfFirst + index + 1}</td>

//                         <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>
//                           {item.WorkOrderUID || item.DemandGenerationID || "-"}
//                         </td>

//                         <td>{item.RABillNumber || "-"}</td>

//                         <td>{item.ContractorName || "-"}</td>

//                         <td>{fmt(item.BillAmount)}</td>

//                         <td>{fmt(item.DeductionAmount)}</td>

//                         <td>{fmt(item.NetPayableAmount)}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="7" style={{ textAlign: "center" }}>
//                         No Demand Generation Data Found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table></div>

//               {/* ================= DEMAND PAGINATION ================= */}
//               {demandGenerationData.length > 0 && (
//                 <div className="project-pagination">
//                   {/* PAGINATION INFO */}
//                   <div className="project-pagination-info">
//                     Showing {demandIndexOfFirst + 1} to{" "}
//                     {Math.min(demandIndexOfLast, demandGenerationData.length)}{" "}
//                     of {demandGenerationData.length} entries
//                   </div>

//                   <div className="project-pagination-controls">
//                     {/* PREVIOUS */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setDemandCurrentPage((prev) => Math.max(prev - 1, 1))
//                       }
//                       disabled={demandCurrentPage === 1}
//                     >
//                       ‹ Previous
//                     </button>

//                     {/* PAGE NUMBERS */}
//                     <div className="project-page-numbers">
//                       {getPageNumbers(demandCurrentPage, demandTotalPages).map(
//                         (pageNumber, index) =>
//                           pageNumber === "..." ? (
//                             <span key={`demand-dots-${index}`}>...</span>
//                           ) : (
//                             <button
//                               type="button"
//                               key={`demand-page-${pageNumber}`}
//                               className={
//                                 demandCurrentPage === pageNumber ? "active" : ""
//                               }
//                               onClick={() => setDemandCurrentPage(pageNumber)}
//                             >
//                               {pageNumber}
//                             </button>
//                           ),
//                       )}
//                     </div>

//                     {/* NEXT */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setDemandCurrentPage((prev) =>
//                           Math.min(prev + 1, demandTotalPages),
//                         )
//                       }
//                       disabled={demandCurrentPage >= demandTotalPages}
//                     >
//                       Next ›
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* =================================================
//             DEDUCTION
//         ================================================= */}

//           {showTable === "deduction" && selectedWorkOrder === "" && (
//             <div className="table-responsive" style={{ width: "100%" }}>
//               <div className="table-vscroll">
//               <table className="custom-table">
//                 <thead>
//                   <tr>
//                     <th style={{ width: "60px" }}>Sr No</th>
//                     <th>Work Order Number</th>
//                     <th>Project Name</th>
//                     <th>Work Name</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {currentDeductionWorkOrders.length > 0 ? (
//                     currentDeductionWorkOrders.map((item, index) => (
//                       <tr key={item.ID || item.WorkOrderUID || index}>
//                         {/* SR NO */}
//                         <td>{deductionWorkOrderIndexOfFirst + index + 1}</td>

//                         {/* WORK ORDER NUMBER */}
//                         <td>
//                           <button
//                             type="button"
//                             style={{
//                               border: "none",
//                               background: "none",
//                               color: "#0d6efd",
//                               textDecoration: "underline",
//                               cursor: "pointer",
//                             }}
//                             onClick={() =>
//                               loadDeductionDetails(item.WorkOrderUID)
//                             }
//                           >
//                             {item.WorkOrderUID || "-"}
//                           </button>
//                         </td>

//                         {/* PROJECT NAME */}
//                         <td>{item.ProjectName || "-"}</td>

//                         {/* WORK NAME */}
//                         <td>{item.WorkName || "-"}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="4" style={{ textAlign: "center" }}>
//                         No Deduction Work Orders Found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table></div>

//               {/* ================= DEDUCTION WORK ORDER PAGINATION ================= */}
//               {/* 15-10 */}
// {deductionWorkOrderTableData.length > 0 && (
//   <div className="project-pagination">
//     <div className="project-pagination-info">
//       Showing {deductionWorkOrderIndexOfFirst + 1} to{" "}
//       {Math.min(
//         deductionWorkOrderIndexOfLast,
//         deductionWorkOrderTableData.length,
//       )}{" "}
//       of {deductionWorkOrderTableData.length} entries
//     </div>

//                   <div className="project-pagination-controls">
//                     {/* PREVIOUS */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setDeductionWorkOrderCurrentPage((prev) =>
//                           Math.max(prev - 1, 1),
//                         )
//                       }
//                       disabled={deductionWorkOrderCurrentPage === 1}
//                     >
//                       ‹ Previous
//                     </button>

//                     {/* PAGE NUMBERS */}
//                     <div className="project-page-numbers">
//                       {getPageNumbers(
//                         deductionWorkOrderCurrentPage,
//                         deductionWorkOrderTotalPages,
//                       ).map((pageNumber, index) =>
//                         pageNumber === "..." ? (
//                           <span key={`deduction-workorder-dots-${index}`}>
//                             ...
//                           </span>
//                         ) : (
//                           <button
//                             type="button"
//                             key={`deduction-workorder-page-${pageNumber}`}
//                             className={
//                               deductionWorkOrderCurrentPage === pageNumber
//                                 ? "active"
//                                 : ""
//                             }
//                             onClick={() =>
//                               setDeductionWorkOrderCurrentPage(pageNumber)
//                             }
//                           >
//                             {pageNumber}
//                           </button>
//                         ),
//                       )}
//                     </div>

//                     {/* NEXT */}
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setDeductionWorkOrderCurrentPage((prev) =>
//                           Math.min(prev + 1, deductionWorkOrderTotalPages),
//                         )
//                       }
//                       disabled={
//                         deductionWorkOrderCurrentPage >=
//                         deductionWorkOrderTotalPages
//                       }
//                     >
//                       Next ›
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           )}

//           {/* ====Afyer selecting the Work order ID== */}

//           {showTable === "deduction" && selectedWorkOrder !== "" && (
//             <>
//               <div style={{ marginBottom: 15 }}>
//                 {/* Back button if required */}
//               </div>

//               <div className="table-responsive" style={{ width: "100%" }}>
//                  <div className="table-vscroll">
//                 <table className="custom-table">
//                   <thead>
//                     <tr>
//                       <th style={{ width: "60px" }}>Sr No</th>
//                       <th>Deduction Name</th>
//                       <th>Deduction Amount</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {currentDeductionDetails.length > 0 ? (
//                       <>
//                         {currentDeductionDetails.map((item, index) => (
//                           <tr key={item.ID || index}>
//                             <td>{deductionDetailsIndexOfFirst + index + 1}</td>

//                             <td>{item.DeductionName || "-"}</td>

//                             <td>{fmt(item.DeductionAmount)}</td>
//                           </tr>
//                         ))}

//                         {/* TOTAL */}
//                         <tr>
//                           <td colSpan="2" style={{ fontWeight: "bold" }}>
//                             Total
//                           </td>

//                           <td style={{ fontWeight: "bold" }}>
//                             {fmt(
//                               deductionDetails.reduce(
//                                 (sum, item) =>
//                                   sum + Number(item.DeductionAmount || 0),
//                                 0,
//                               ),
//                             )}
//                           </td>
//                         </tr>
//                       </>
//                     ) : (
//                       <tr>
//                         <td colSpan="3" style={{ textAlign: "center" }}>
//                           No Deduction Details Found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
// </div>
//                 {/* ================= DEDUCTION DETAILS PAGINATION ================= */}
//                 {deductionDetails.length > 0 && (
//                   <div className="project-pagination">
//                     {/* PAGINATION INFO */}
//                     <div className="project-pagination-info">
//                       Showing {deductionDetailsIndexOfFirst + 1} to{" "}
//                       {Math.min(
//                         deductionDetailsIndexOfLast,
//                         deductionDetails.length,
//                       )}{" "}
//                       of {deductionDetails.length} entries
//                     </div>

//                     <div className="project-pagination-controls">
//                       {/* PREVIOUS */}
//                       <button
//                         type="button"
//                         onClick={() =>
//                           setDeductionDetailsCurrentPage((prev) =>
//                             Math.max(prev - 1, 1),
//                           )
//                         }
//                         disabled={deductionDetailsCurrentPage === 1}
//                       >
//                         ‹ Previous
//                       </button>

//                       {/* PAGE NUMBERS */}
//                       <div className="project-page-numbers">
//                         {getPageNumbers(
//                           deductionDetailsCurrentPage,
//                           deductionDetailsTotalPages,
//                         ).map((pageNumber, index) =>
//                           pageNumber === "..." ? (
//                             <span key={`deduction-details-dots-${index}`}>
//                               ...
//                             </span>
//                           ) : (
//                             <button
//                               type="button"
//                               key={`deduction-details-page-${pageNumber}`}
//                               className={
//                                 deductionDetailsCurrentPage === pageNumber
//                                   ? "active"
//                                   : ""
//                               }
//                               onClick={() =>
//                                 setDeductionDetailsCurrentPage(pageNumber)
//                               }
//                             >
//                               {pageNumber}
//                             </button>
//                           ),
//                         )}
//                       </div>

//                       {/* NEXT */}
//                       <button
//                         type="button"
//                         onClick={() =>
//                           setDeductionDetailsCurrentPage((prev) =>
//                             Math.min(prev + 1, deductionDetailsTotalPages),
//                           )
//                         }
//                         disabled={
//                           deductionDetailsCurrentPage >=
//                           deductionDetailsTotalPages
//                         }
//                       >
//                         Next ›
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </>
//           )}

//           {showTable === "releaseamount" && (
//             <div className="table-responsive">
//                 <div className="table-vscroll">
//               <table className="custom-table">
              
//                 <thead>
//                   <tr>
//                     <th style={{ width: "60px" }}>Sr. No</th>
//                     <th>Limit ID</th>
//                     <th>Financial Year</th>
//                     <th>Project Name</th>
//                     <th>Limit Amount</th>
//                     <th>Release Date</th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {releaseAmountData.length > 0 ? (
//                     <>
//                       {currentReleaseAmounts.map((item, index) => (
//                         <tr key={item.ID}>
//                           <td>{releaseAmountIndexOfFirst + index + 1}</td>
//                           <td style={{ color: "rgb(82, 149, 201)",textAlign:"center"}}>{item.ReleaseID}</td>

//                           <td>{item.FinancialYear}</td>

//                           <td>{item.ProjectName}</td>

//                           <td>
//                             ₹{" "}
//                             {Number(
//                               item.ReleaseAmountTillDate || 0,
//                             ).toLocaleString("en-IN")}
//                           </td>

//                           <td>
//                             {item.ReleaseDate
//                               ? new Date(item.ReleaseDate).toLocaleDateString(
//                                   "en-IN",
//                                 )
//                               : "-"}
//                           </td>
//                         </tr>
//                       ))}

//                       <tr>
//                         <td colSpan="4" style={{ fontWeight: "bold" }}>
//                           Total
//                         </td>

//                         <td style={{ fontWeight: "bold" }}>
//                           ₹{" "}
//                           {releaseAmountData
//                             .reduce(
//                               (sum, item) =>
//                                 sum + Number(item.ReleaseAmountTillDate || 0),
//                               0,
//                             )
//                             .toLocaleString("en-IN")}
//                         </td>

//                         <td></td>
//                       </tr>
//                     </>
//                   ) : (
//                     <tr>
//                       <td colSpan="6" style={{ textAlign: "center" }}>
//                         No Release Data Found
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table></div>
//               <div className="project-pagination">
//                 <div className="project-pagination-info">
//                   {releaseAmountData.length === 0
//                     ? "Showing 0 to 0 of 0 entries"
//                     : `Showing ${releaseAmountIndexOfFirst + 1} to ${Math.min(
//                         releaseAmountIndexOfLast,
//                         releaseAmountData.length,
//                       )} of ${releaseAmountData.length} entries`}
//                 </div>

//                 {releaseAmountData.length > 0 && (
//                   <div className="project-pagination-controls">
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setReleaseAmountCurrentPage((prev) =>
//                           Math.max(prev - 1, 1),
//                         )
//                       }
//                       disabled={releaseAmountCurrentPage === 1}
//                     >
//                       ‹ Previous
//                     </button>

//                     <div className="project-page-numbers">
//                       {getPageNumbers(
//                         releaseAmountCurrentPage,
//                         releaseAmountTotalPages,
//                       ).map((pageNumber, index) =>
//                         pageNumber === "..." ? (
//                           <span key={`release-dots-${index}`}>...</span>
//                         ) : (
//                           <button
//                             type="button"
//                             key={`release-page-${pageNumber}`}
//                             className={
//                               releaseAmountCurrentPage === pageNumber
//                                 ? "active"
//                                 : ""
//                             }
//                             onClick={() =>
//                               setReleaseAmountCurrentPage(pageNumber)
//                             }
//                           >
//                             {pageNumber}
//                           </button>
//                         ),
//                       )}
//                     </div>
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setReleaseAmountCurrentPage((prev) =>
//                           Math.min(prev + 1, releaseAmountTotalPages),
//                         )
//                       }
//                       disabled={
//                         releaseAmountCurrentPage >= releaseAmountTotalPages
//                       }
//                     >
//                       Next ›
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//       )}
//     </>
//   );
// };

// export default AgencyDashboard;


import React, { useContext, useEffect, useMemo, useState } from "react";
import AdminContext from "../../admin/StateContext/Application";
import ReactApexChart from "react-apexcharts";
import Select from "react-select";
import "./agencydashboard.css";
import { apiurl } from "../../../path";

import {
  FaMapMarkerAlt,
  FaRegCalendarAlt,
  FaRegClock,
  FaMountain,
  FaBullseye,
  FaChartBar,
  FaChevronLeft,
  FaChevronRight,
  FaArrowCircleRight,
  FaUndoAlt,
} from "react-icons/fa";
import { TbLocation } from "react-icons/tb";

import { Approved32, Disable32 } from "../../../public/LoginImages/importimages";

/* =====================================================================
   PURE HELPERS (no component state)
   ===================================================================== */
const PER_PAGE = 10;
const BILLS_PER_PAGE = 5;
const HEADS_PER_PAGE = 8;

const fmt = (n) => Number(n || 0).toLocaleString("en-IN");
const rupee = (n) => `₹ ${fmt(n)}`;
const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-IN") : "-");

// agency code is stored inside the JWT token
const getLoggedInAgencyCode = () => {
  try {
    const token = localStorage.getItem("Token");
    if (!token) return "";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.Agency || "";
  } catch (error) {
    console.error("Error reading agency from token:", error);
    return "";
  }
};

const dedupeBy = (list, key) =>
  Array.from(new Map((list || []).map((item) => [item[key], item])).values());

// true when ANY of the given keys contains the search text
const matches = (item, term, keys) => {
  const s = term.trim().toLowerCase();
  if (!s) return true;
  return keys.some((k) => String(item?.[k] ?? "").toLowerCase().includes(s));
};

const paginate = (list, page, perPage) => {
  const last = page * perPage;
  const first = last - perPage;
  return {
    totalPages: Math.ceil(list.length / perPage),
    first,
    last,
    items: list.slice(first, last),
  };
};

const getPageNumbers = (currentPage, totalPages) => {
  const maxVisiblePages = 10;
  if (totalPages <= maxVisiblePages) {
    return Array.from({ length: totalPages }, (_, i) => i + 1);
  }
  if (currentPage <= 3) return [1, 2, 3, 4, 5, "...", totalPages];
  if (currentPage >= totalPages - 2) {
    return ["...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  }
  return ["...", currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2, "...", totalPages];
};

// page state that jumps back to 1 whenever the reset keys change
const usePage = (resetKeys) => {
  const [page, setPage] = useState(1);
  useEffect(() => {
    setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, resetKeys);
  return [page, setPage];
};

const parseLocations = (location) => {
  try {
    if (Array.isArray(location)) {
      return location.map((loc) => (typeof loc === "string" ? JSON.parse(loc) : loc));
    }
    const parsed = JSON.parse(location || "[]");
    return parsed.map((loc) => (typeof loc === "string" ? JSON.parse(loc) : loc));
  } catch {
    return [];
  }
};

const getDeductionTotal = (item) => Number(item.TotalDeductionAmount ?? item.DeductionAmount ?? 0);

// number of rows the Project Cost table will show (used to reset its page)
const tableDataLength = (projectdata, projectId) =>
  projectId ? projectdata.filter((i) => String(i.ProjectId) === String(projectId)).length : projectdata.length;

/* =====================================================================
   STATIC CONFIG
   ===================================================================== */
const TABLE_TITLES = {
  projectCost: "Project Cost Details",
  estimate: "Estimate Amount Details",
  progress: "Progress Report Details",
  releaseamount: "Limit Allocation Details",
  workOrder: "Work Order Details",
  demand: "Demand Generation Details",
  deduction: "Deduction Amount Details",
};

const PHOTO_THEME = { border: "#3b82f6", bg: "#f3f8ff", iconBg: "#dbeafe", icon: "#3b82f6" };

const SPEND_SERIES = [
  { name: "High - 2013", data: [28, 29, 33, 36, 32, 32, 33] },
  { name: "Low - 2013", data: [12, 11, 14, 18, 17, 13, 13] },
];

const SPEND_OPTIONS = {
  chart: { type: "area", width: "100%", parentHeightOffset: 0, zoom: { enabled: false }, toolbar: { show: false } },
  colors: ["#1e9e6a", "#f0583f"],
  stroke: { width: [4, 4], curve: "smooth" },
  fill: {
    type: "gradient",
    gradient: { shade: "light", type: "vertical", opacityFrom: 0.45, opacityTo: 0, stops: [0, 100] },
  },
  dataLabels: { enabled: false },
  grid: { borderColor: "#c9d3e3", strokeDashArray: 3 },
  markers: { size: 0, hover: { size: 6 } },
  tooltip: { enabled: true, theme: "dark" },
  xaxis: {
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul"],
    labels: { style: { colors: "#6b7280", fontSize: "12px" } },
  },
  yaxis: { labels: { style: { colors: "#6b7280", fontSize: "12px" } } },
  legend: { show: true, position: "top", horizontalAlign: "center", fontSize: "11px" },
};

const DONUT_BASE_OPTIONS = {
  chart: { width: 250, type: "pie" },
  labels: ["Project Cost", "Release Amount", "Demand Generated"],
  legend: {
    position: "bottom",
    horizontalAlign: "center",
    fontSize: "13px",
    markers: { radius: 12, width: 12, height: 12 },
  },
  dataLabels: { enabled: false },
  colors: ["#38d1bd", "#50bdf5", "#ee574c", "#7f47dd"],
  responsive: [{ breakpoint: 480, options: { chart: { width: 200 }, legend: { position: "bottom" } } }],
};

const DEDUCTION_PIE_BASE = {
  chart: { width: 380, type: "pie" },
  labels: [],
  legend: { position: "bottom", horizontalAlign: "center", fontSize: "14px", markers: { radius: 12 } },
  responsive: [{ breakpoint: 480, options: { chart: { width: 200 }, legend: { position: "bottom" } } }],
};

/* react-select */
const DASH_SELECT_PROPS = {
  isSearchable: true,
  isClearable: true,
  menuPosition: "fixed",
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
};

const dashSelectStyles = (width) => ({
  container: (b) => ({ ...b, width }),
  control: (b, s) => ({
    ...b,
    width,
    minHeight: "40px",
    height: "40px",
    borderRadius: "6px",
    border: "1px solid #cfd4dc",
    boxShadow: s.isFocused ? "0 0 0 1px #2684ff" : "none",
    backgroundColor: "#fff",
    cursor: "pointer",
    fontSize: "13px",
  }),
  valueContainer: (b) => ({ ...b, padding: "2px 10px" }),
  input: (b) => ({ ...b, fontSize: "13px" }),
  placeholder: (b) => ({ ...b, color: "#777", fontSize: "13px", whiteSpace: "nowrap" }),
  singleValue: (b) => ({
    ...b,
    color: "#222",
    fontSize: "13px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (b) => ({ ...b, color: "#999", padding: "6px 8px" }),
  clearIndicator: (b) => ({ ...b, padding: "6px" }),
  menu: (b) => ({
    ...b,
    width,
    marginTop: "4px",
    borderRadius: "6px",
    overflow: "hidden",
    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
    zIndex: 99999,
  }),
  menuList: (b) => ({ ...b, maxHeight: "220px", overflowY: "auto", padding: "4px 0" }),
  menuPortal: (b) => ({ ...b, zIndex: 99999 }),
  option: (b, s) => ({
    ...b,
    fontSize: "13px",
    padding: "10px 12px",
    backgroundColor: s.isSelected ? "#0d6efd" : s.isFocused ? "#eaf3ff" : "#fff",
    color: s.isSelected ? "#fff" : "#222",
    cursor: "pointer",
  }),
});

/* =====================================================================
   SMALL PRESENTATION COMPONENTS
   ===================================================================== */

// theme = blue | purple | orange | green | pink | indigo | teal | red
const DashStatCard = ({ theme, icon, title, value, onClick, tall = false }) => (
  <div className={`agencyDash-card agencyDash-card--${theme}${tall ? " agencyDash-card--tall" : ""}`}>
    <button type="button" className="agencyDash-card__arrow" onClick={onClick} aria-label={`Open ${title}`}>
      <FaArrowCircleRight />
    </button>

    <div className="agencyDash-card__icon">
      <img src={icon} alt="" />
    </div>

    <div className="agencyDash-card__body">
      <p className="agencyDash-card__title">{title}</p>
      <h3 className="agencyDash-card__value">{value}</h3>
    </div>

    <div className="agencyDash-card__bar">
      <span />
    </div>
  </div>
);

// info = "Showing 1 to 10 of 50 entries" (optional), compact = small panel pager
const DashPagination = ({ page, totalPages, onPage, info, compact = false }) => (
  <div className={`agencyDash-pagination${compact ? " agencyDash-pagination--end" : ""}`}>
    {info && <div className="agencyDash-pagination-info">{info}</div>}

    <div className="agencyDash-pagination-controls">
      <button type="button" className="agencyDash-nav-btn" onClick={() => onPage(Math.max(page - 1, 1))} disabled={page === 1}>
        ‹ Previous
      </button>

      <div className="agencyDash-page-numbers">
        {getPageNumbers(page, totalPages).map((n, i) =>
          n === "..." ? (
            <span key={`dots-${i}`}>...</span>
          ) : (
            <button type="button" key={n} className={page === n ? "is-active" : ""} onClick={() => onPage(n)}>
              {n}
            </button>
          ),
        )}
      </div>

      <button
        type="button"
        className="agencyDash-nav-btn"
        onClick={() => onPage(Math.min(page + 1, totalPages))}
        disabled={page >= totalPages}
      >
        Next ›
      </button>
    </div>
  </div>
);

const PhotoInfoRow = ({ icon, label, value }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "7px", fontSize: "11px" }}>
    <span
      style={{
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: PHOTO_THEME.iconBg,
        color: PHOTO_THEME.icon,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        flexShrink: 0,
      }}
    >
      {icon}
    </span>
    <span>
      <b>{label}:</b> {value}
    </span>
  </div>
);

/* =====================================================================
   MAIN COMPONENT
   ===================================================================== */
const AgencyDashboard = () => {
  const content = useContext(AdminContext);
  const {
    Usermenu,
    GetAgnecyWiseTaxAmount,
    GetVendorBills,
    GetProjectInfo,
    getTaxAmountsByDate,
    GetAgencyWiseData,
    GetBudgetHeadInfo,
    GetAgencyDashboardData,
  } = content;

  const agencyCode = getLoggedInAgencyCode();

  /* ---------------- state (same as your original) ---------------- */
  const [getData, SetData] = useState({});
  const [menuData, setMenuData] = useState({});
  const [vendorbills, setVendorBills] = useState([]);
  const [loading, setloading] = useState(true);
  const [dateData, setDateData] = useState([]);
  const [projectdata, setProjectData] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [headFetchedData, setHeadFetchedData] = useState([]);
  const [, setHeadEstimationData] = useState([]);
  const [deductionData, setDeductionData] = useState([]);

  const [FetchedImages, setFetchedImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedUploadId, setSelectedUploadID] = useState();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [showSpecific, setShowSpecific] = useState(0);

  const [showTable, setShowTable] = useState(null);
  const [progressData, setProgressData] = useState([]);
  const [estimateData, setEstimateData] = useState([]);
  const [workOrderData, setWorkOrderData] = useState([]);
  const [demandGenerationData, setDemandGenerationData] = useState([]);
  const [releaseAmountData, setReleaseAmountData] = useState([]);
  const [deductionWorkOrders, setDeductionWorkOrders] = useState([]);
  const [deductionDetails, setDeductionDetails] = useState([]);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState("");
  const [searchText, setSearchText] = useState("");

  /* ---------------- pagination state ---------------- */
  const [vendorCurrentPage, setVendorCurrentPage] = useState(1);
  const [headCurrentPage, setHeadCurrentPage] = useState(1);
  const [projectCostPage, setProjectCostPage] = usePage([tableDataLength(projectdata, projectId), projectId, searchText]);
  const [estimatePage, setEstimatePage] = usePage([estimateData.length, projectId, searchText]);
  const [progressPage, setProgressPage] = usePage([progressData.length, projectId, searchText]);
  const [workOrderPage, setWorkOrderPage] = usePage([workOrderData.length, projectId, searchText]);
  const [demandPage, setDemandPage] = usePage([demandGenerationData.length, projectId, searchText]);
  const [releasePage, setReleasePage] = usePage([releaseAmountData.length, projectId, searchText]);
  const [deductionPage, setDeductionPage] = usePage([deductionWorkOrders.length, projectId, searchText]);
  const [deductionDetailsPage, setDeductionDetailsPage] = usePage([
    deductionDetails.length,
    projectId,
    searchText,
    selectedWorkOrder,
  ]);

  /* ---------------- donut / pie chart state (same as original) ---------------- */
  const [state4, setState4] = useState({ series: [0, 0, 0, 0], options: DONUT_BASE_OPTIONS });
  const [state5, setState5] = useState({ series: [], options: DEDUCTION_PIE_BASE });

  /* =====================================================================
     DATA LOADING (your original calls, unchanged)
     ===================================================================== */
  const GetAmountOfTaxes = async () => {
    const data = await GetAgnecyWiseTaxAmount();
    SetData(data);
    setloading(false);
  };

  const GetAllProjectTotal = async () => {
    try {
      const data = await GetProjectInfo("", "getProjectsByHead");
      const projects = Array.isArray(data) ? data : [];
      setProjectData(dedupeBy(projects, "ProjectId"));
    } catch (err) {
      console.error("Error fetching projects:", err);
      setProjectData([]);
    }
  };

  const getVendorbill = async () => {
    const data1 = await GetVendorBills();
    const bills = data1.filter((item) => item.BillNumber == projectId);
    setVendorBills(bills);
  };

  const getTaxesAmountbyDate = async () => {
    await getTaxAmountsByDate();
  };

  const GetHeadBugetEstimationTable = async (PID) => {
    try {
      const res = await GetProjectInfo(PID, "getprojectHeadEstimationamount");
      setHeadEstimationData(Array.isArray(res) ? res : []);
    } catch (err) {
      console.log(err);
    }
  };

  const GetHeadBuget = async () => {
    try {
      const res = await GetBudgetHeadInfo("null", "all");
      setHeadFetchedData(Array.isArray(res) ? res : []);
    } catch (err) {
      console.log(err);
    }
  };

  const getAgencyWiseData = async () => {
    if (!projectId) return;
    setloading(true);
    const data = await GetAgencyWiseData(projectId, "Projectfetching");
    if (data) {
      setDateData(data);
      setloading(false);
    }
  };

  const getDeductionData = async () => {
    try {
      setloading(true);
      const data = await GetAgencyWiseData(projectId, "deductionFetching");
      setDeductionData(data);
    } catch (err) {
      console.log(err);
    } finally {
      setloading(false);
    }
  };

  const loadDeductionWorkOrders = async () => {
    try {
      const data = await GetAgencyDashboardData({
        agencyCode,
        projectId: projectId || "",
        type: "deductionWorkOrder",
      });
      setDeductionWorkOrders(Array.isArray(data) ? data : []);
      setSelectedWorkOrder("");
      setDeductionDetails([]);
    } catch (err) {
      console.error(err);
    }
  };

  const loadDeductionDetails = async (workOrderUID) => {
    try {
      const data = await GetAgencyDashboardData({ agencyCode, type: "deductionDetails", workOrderUID });
      setSelectedWorkOrder(workOrderUID);
      setDeductionDetails(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Deduction Details Error:", error);
      setDeductionDetails([]);
    }
  };

  const fetchSpecficUploadPhoto = async (uploadID) => {
    try {
      const res = await GetBudgetHeadInfo(uploadID, "GetSpecificUploadImagesfromProgressTable");
      const allImages = Array.isArray(res) ? res : Array.isArray(res?.Data) ? res.Data : [];
      const filteredImages = allImages.filter(
        (image) => String(image.UploadID).trim() === String(uploadID).trim(),
      );
      setFetchedImages(filteredImages);
      setSelectedUploadID(uploadID);
      setCurrentSlide(0);
      setShowSpecific(1);
    } catch (err) {
      console.error("Image API error:", err);
    }
  };

  /* =====================================================================
     EFFECTS (same order and same dependencies as your original)
     ===================================================================== */
  useEffect(() => {
    GetAmountOfTaxes();
    getTaxesAmountbyDate();
    GetAllProjectTotal();
    GetHeadBuget();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      setMenuData(res?.Data || {});
    };
    getMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // clear the search box when a different table / work order opens
  useEffect(() => {
    setSearchText("");
  }, [showTable, selectedWorkOrder]);

  // estimate + work order
  useEffect(() => {
    if (!agencyCode) return;
    const loadDashboardData = async (selectedProjectId = "") => {
      try {
        const estimate = await GetAgencyDashboardData({ agencyCode, projectId: selectedProjectId, type: "estimate" });
        const workorder = await GetAgencyDashboardData({ agencyCode, projectId: selectedProjectId, type: "workorder" });
        setEstimateData(Array.isArray(estimate) ? estimate : []);
        setWorkOrderData(Array.isArray(workorder) ? workorder : []);
      } catch (error) {
        console.error("Dashboard Data Error:", error);
        setEstimateData([]);
        setWorkOrderData([]);
      }
    };
    loadDashboardData(projectId || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, agencyCode]);

  // agency projects
  useEffect(() => {
    const loadAgencyProjects = async () => {
      if (!agencyCode) return;
      try {
        const data = await GetAgencyDashboardData({ agencyCode, type: "project", projectId: "" });
        setProjectData(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Agency projects error:", error);
        setProjectData([]);
      }
    };
    loadAgencyProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agencyCode]);

  // progress report
  useEffect(() => {
    const loadProgressReport = async () => {
      if (!agencyCode) return;
      try {
        const response = await GetAgencyDashboardData({ agencyCode, projectId: projectId || "", type: "progress" });
        setProgressData(Array.isArray(response) ? response : []);
      } catch (error) {
        console.error("PROGRESS ERROR:", error);
        setProgressData([]);
      }
    };
    loadProgressReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, agencyCode]);

  // work orders
  useEffect(() => {
    const loadWorkOrder = async () => {
      if (!agencyCode) return;
      try {
        const data = await GetAgencyDashboardData({ agencyCode, projectId: projectId || "", type: "workorder" });
        setWorkOrderData(Array.isArray(data) ? data : []);
        setWorkOrderPage(1);
      } catch (error) {
        console.error("WORK ORDER ERROR:", error);
        setWorkOrderData([]);
      }
    };
    loadWorkOrder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, agencyCode]);

  // demand generation
  useEffect(() => {
    const loadDemandGeneration = async () => {
      if (!agencyCode) return;
      try {
        const data = await GetAgencyDashboardData({ agencyCode, projectId: projectId || "", type: "demand" });
        setDemandGenerationData(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("DEMAND GENERATION ERROR:", error);
        setDemandGenerationData([]);
      }
    };
    loadDemandGeneration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, agencyCode]);

  // release amount (limit allocation)
  useEffect(() => {
    const loadReleaseAmount = async () => {
      if (!agencyCode) return;
      try {
        const data = await GetAgencyDashboardData({ agencyCode, projectId: projectId || "", type: "releaseamount" });
        setReleaseAmountData(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error(error);
        setReleaseAmountData([]);
      }
    };
    loadReleaseAmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, agencyCode]);

  // head data for the selected project
  useEffect(() => {
    if (projectId) {
      GetHeadBugetEstimationTable(projectId);
      GetHeadBuget();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  // project selected / cleared
  useEffect(() => {
    if (projectId === "") {
      setDateData({});
      return;
    }
    getAgencyWiseData();
    getVendorbill();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  useEffect(() => {
    if (projectId) {
      getDeductionData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  // chart numbers (same formulas as your original)
  useEffect(() => {
    if (getData || dateData) {
      setState4((prevState) => ({
        ...prevState,
        series: [
          dateData.Project_Cost ? dateData.Project_Cost : getData.Project_Cost || 0,
          dateData.ReleaseAmountTillDate ? dateData.ReleaseAmountTillDate : getData.ReleaseAmountTillDate || 0,
          dateData.LiabalityAmount ? dateData.LiabalityAmount : getData.LiabalityAmount || 0,
          dateData.TotalWorkOrders ? dateData.TotalWorkOrders : getData.TotalWorkOrders || 0,
        ],
      }));
    }
  }, [getData, dateData]);

  useEffect(() => {
    if (deductionData && deductionData.length > 0) {
      setState5((prev) => ({
        ...prev,
        series: deductionData.map((item) => parseFloat(item.TotalAmount)),
        options: { ...prev.options, labels: deductionData.map((item) => item.TypeOfAmount) },
      }));
    }
  }, [deductionData]);

  /* =====================================================================
     DERIVED VALUES (same as your original)
     ===================================================================== */
  const displayData = projectId ? dateData : getData;

  const canViewProjectSelect =
    (menuData?.Department_Name === "Agency Maker" && menuData?.Role === "Agency Maker") ||
    (menuData?.Department_Name === "Agency Admin" && menuData?.Role === "Agency Admin") ||
    (menuData?.Department_Name === "Agency Checker" && menuData?.Role === "Agency Checker");

  const agencyProjects = (projectdata || []).filter(
    (p) => String(p.PIU).trim() === String(agencyCode).trim(),
  );

  const projectOptions = agencyProjects.map((p) => ({ value: p.ProjectId, label: p.ProjectName }));
  const selectedProjectOption =
    projectOptions.find((o) => String(o.value) === String(projectId)) || null;

  const tableData = projectId
    ? projectdata.filter((item) => String(item.ProjectId) === String(projectId))
    : projectdata;

  const totalWorkOrders = Array.isArray(workOrderData) ? workOrderData.length : 0;

  const totalReleaseAmount = Array.isArray(releaseAmountData)
    ? releaseAmountData.reduce((sum, item) => sum + Number(item.ReleaseAmountTillDate || 0), 0)
    : 0;

  // Vendor Bills panel
  const vendorPg = paginate(vendorbills, vendorCurrentPage, BILLS_PER_PAGE);

  // Head Details panel (grouped by head, same source as your original)
  const headTableData = Object.entries(
    headFetchedData.reduce((acc, val) => {
      acc[val.BudgetHead] = (acc[val.BudgetHead] || 0) + (parseFloat(val.EsitmateAmount) || 0);
      return acc;
    }, {}),
  );
  const headPg = paginate(headTableData, headCurrentPage, HEADS_PER_PAGE);

  /* ---------------- filtered + paginated drill-down lists ---------------- */
  const getDeductionTotal = (item) => Number(item.TotalDeductionAmount ?? item.DeductionAmount ?? 0);

  const projectCostList = tableData.filter((i) =>
    matches(i, searchText, ["FinancialYear", "ProjectName", "Agency_Name", "PIU", "ProjectCost", "GRNumber"]),
  );
  const estimateList = estimateData.filter((i) =>
    matches(i, searchText, ["ProjectID", "ProjectName", "Year", "BudgetHead", "ObjectCode", "EsitmateAmount"]),
  );
  const progressList = progressData.filter((i) =>
    matches(i, searchText, ["FinancialYear", "ProjectName", "WorkName", "PhysicalProgress"]),
  );
  const releaseList = releaseAmountData.filter((i) =>
    matches(i, searchText, ["ReleaseID", "FinancialYear", "ProjectName", "ReleaseAmountTillDate"]),
  );
  const workOrderList = workOrderData.filter((i) =>
    matches(i, searchText, ["FinancialYear", "ProjectName", "ProjectCost", "CreatedByAgency", "WorkOrderNo"]),
  );
  const demandList = demandGenerationData.filter((i) =>
    matches(i, searchText, ["WorkOrderUID", "DemandGenerationID", "RABillNumber", "ContractorName", "BillAmount", "DeductionAmount", "NetPayableAmount"]),
  );
  const deductionList = deductionWorkOrders
    .filter((i) => getDeductionTotal(i) > 0)
    .filter((i) => matches(i, searchText, ["WorkOrderUID", "ProjectName", "WorkName"]));
  const deductionDetailsList = deductionDetails.filter((i) =>
    matches(i, searchText, ["DeductionName", "DeductionAmount", "ID"]),
  );

  const projectCostPg = paginate(projectCostList, projectCostPage, PER_PAGE);
  const estimatePg = paginate(estimateList, estimatePage, PER_PAGE);
  const progressPg = paginate(progressList, progressPage, PER_PAGE);
  const releasePg = paginate(releaseList, releasePage, PER_PAGE);
  const workOrderPg = paginate(workOrderList, workOrderPage, PER_PAGE);
  const demandPg = paginate(demandList, demandPage, PER_PAGE);
  const deductionPg = paginate(deductionList, deductionPage, PER_PAGE);
  const deductionDetailsPg = paginate(deductionDetailsList, deductionDetailsPage, PER_PAGE);

  /* =====================================================================
     HANDLERS
     ===================================================================== */
  const handleProjectChange = (value) => setProjectId(value || "");

  // deduction details -> back to the work-order list; any other table -> dashboard
  const handleBack = () => {
    if (showTable === "deduction" && selectedWorkOrder !== "") {
      setSelectedWorkOrder("");
      setDeductionDetails([]);
      return;
    }
    setShowTable(null);
  };

  /* =====================================================================
     DRILL-DOWN TABLE DEFINITIONS (one place describes every table)
     ===================================================================== */
  const tableViews = {
    projectCost: {
      list: projectCostList, pg: projectCostPg, page: projectCostPage, setPage: setProjectCostPage,
      empty: "No Project Cost Data Found",
      cols: [
        { head: "Financial Year", cell: (r) => r.FinancialYear || "-" },
        { head: "Project Name", cell: (r) => r.ProjectName || "-" },
        { head: "Implementing Agency", link: true, cell: (r) => r.Agency_Name || r.PIU || "-" },
        { head: "Project Cost", amount: true, cell: (r) => rupee(r.ProjectCost) },
        { head: "GR Number", cell: (r) => r.GRNumber || "-" },
        { head: "GR Date", cell: (r) => fmtDate(r.GRDate) },
        { head: "Creation Date", cell: (r) => fmtDate(r.Date) },
      ],
    },
    estimate: {
      list: estimateList, pg: estimatePg, page: estimatePage, setPage: setEstimatePage,
      empty: "No estimate found",
      cols: [
        { head: "Project ID", link: true, cell: (r) => r.ProjectID || "-" },
        { head: "Project Name", cell: (r) => r.ProjectName || "-" },
        { head: "Financial Year", cell: (r) => r.Year || "-" },
        { head: "Budget Head", cell: (r) => r.BudgetHead || "-" },
        { head: "Object Code", cell: (r) => r.ObjectCode || "-" },
        { head: "Estimate Amount", amount: true, cell: (r) => rupee(r.EsitmateAmount) },
        { head: "Creation Date", cell: (r) => fmtDate(r.Date) },
      ],
    },
    progress: {
      list: progressList, pg: progressPg, page: progressPage, setPage: setProgressPage,
      empty: "No progress report found",
      cols: [
        { head: "Financial Year", cell: (r) => r.FinancialYear || "-" },
        { head: "Project Name", cell: (r) => r.ProjectName || "-" },
        { head: "Work Name", cell: (r) => r.WorkName || "-" },
        {
          head: "Physical Progress %",
          cell: (r) => (
            <button type="button" className="agencyDash-view-btn" onClick={() => fetchSpecficUploadPhoto(r.UploadID)}>
              View Photos
            </button>
          ),
        },
        { head: "Creation Date", cell: (r) => fmtDate(r.CreationDate) },
      ],
    },
    releaseamount: {
      list: releaseList, pg: releasePg, page: releasePage, setPage: setReleasePage,
      empty: "No Release Data Found",
      footer: { span: 4, value: rupee(totalReleaseAmount), after: 1 },
      cols: [
        { head: "Limit ID", link: true, cell: (r) => r.ReleaseID },
        { head: "Financial Year", cell: (r) => r.FinancialYear },
        { head: "Project Name", cell: (r) => r.ProjectName },
        { head: "Limit Amount", amount: true, cell: (r) => rupee(r.ReleaseAmountTillDate) },
        { head: "Release Date", cell: (r) => fmtDate(r.ReleaseDate) },
      ],
    },
    workOrder: {
      list: workOrderList, pg: workOrderPg, page: workOrderPage, setPage: setWorkOrderPage,
      empty: "No Work Order Data Found",
      cols: [
        { head: "Financial Year", cell: (r) => r.FinancialYear || "-" },
        { head: "Work Order Number", link: true, cell: (r) => r.WorkOrderNo || "-" },
        { head: "Project Name", cell: (r) => r.ProjectName || "-" },
        { head: "Project Cost", amount: true, cell: (r) => fmt(r.ProjectCost) },
        { head: "Agency Name", cell: (r) => r.CreatedByAgency || "-" },
        { head: "Work Creation Date", cell: (r) => fmtDate(r.WorkOrderDate) },
      ],
    },
    demand: {
      list: demandList, pg: demandPg, page: demandPage, setPage: setDemandPage,
      empty: "No Demand Generation Data Found",
      cols: [
        { head: "Bill UID", link: true, cell: (r) => r.WorkOrderUID || r.DemandGenerationID || "-" },
        { head: "RA Bill Number", cell: (r) => r.RABillNumber || "-" },
        { head: "Contractor Name", cell: (r) => r.ContractorName || "-" },
        { head: "Bill Amount", amount: true, cell: (r) => fmt(r.BillAmount) },
        { head: "Deduction Amount", amount: true, cell: (r) => fmt(r.DeductionAmount) },
        { head: "Payable Amount", amount: true, cell: (r) => fmt(r.NetPayableAmount) },
      ],
    },
    deduction: {
      list: deductionList, pg: deductionPg, page: deductionPage, setPage: setDeductionPage,
      empty: "No Deduction Work Orders Found",
      cols: [
        {
          head: "Work Order Number",
          cell: (r) => (
            <span className="agencyDash-link" onClick={() => loadDeductionDetails(r.WorkOrderUID)}>
              {r.WorkOrderUID || "-"}
            </span>
          ),
        },
        { head: "Project Name", cell: (r) => r.ProjectName || "-" },
        { head: "Work Name", cell: (r) => r.WorkName || "-" },
      ],
    },
  };

  /* =====================================================================
     RENDER: PHOTO VIEWER
     ===================================================================== */
  const renderPhotoViewer = () => {
    const cards = [];

    (FetchedImages || []).forEach((val, index) => {
      const images = val.Upload ? val.Upload.split(",").map((img) => img.trim()) : [];

      const locations = (() => {
        try {
          if (!val.Location) return [];
          if (typeof val.Location === "string" && val.Location.includes(",") && !val.Location.startsWith("[")) {
            const [lat, lng] = val.Location.split(",");
            const dt = val.Date ? new Date(val.Date) : null;
            return [
              {
                latitude: lat?.trim(),
                longitude: lng?.trim(),
                date: dt ? dt.toLocaleDateString("en-GB") : "-",
                time: dt ? dt.toLocaleTimeString("en-GB", { hour12: false }) : "-",
                elevation: "",
                accuracy: "",
              },
            ];
          }
          return parseLocations(val.Location);
        } catch {
          return [];
        }
      })();

      images.forEach((img, imgIndex) => {
        cards.push({
          key: `${index}-${imgIndex}`,
          img,
          location: locations[imgIndex] || locations[0] || {},
          progress: val.PhysicalProgress,
        });
      });
    });

    const total = cards.length;
    const current = cards[currentSlide] || cards[0];
    const loc = current?.location || {};
    const goPrev = () => setCurrentSlide((p) => (p - 1 + total) % total);
    const goNext = () => setCurrentSlide((p) => (p + 1) % total);

    const arrowStyle = (side) => ({
      position: "absolute",
      top: "50%",
      [side]: "10px",
      transform: "translateY(-50%)",
      width: "34px",
      height: "34px",
      borderRadius: "50%",
      border: "none",
      backgroundColor: "rgba(255,255,255,0.92)",
      boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
      color: "#333",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      zIndex: 2,
    });

    return (
      <div className="agencyDash-photo-page">
        <h6 className="agencyDash-photo-title">Uploaded Id: {selectedUploadId}</h6>

        {total > 0 ? (
          <div
            style={{
              maxWidth: "380px",
              margin: "0 auto",
              border: `1.5px solid ${PHOTO_THEME.border}`,
              borderRadius: "10px",
              backgroundColor: PHOTO_THEME.bg,
              padding: "10px",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "240px",
                borderRadius: "14px",
                overflow: "hidden",
                backgroundColor: "#eee",
              }}
            >
              <div
                style={{
                  display: "flex",
                  height: "100%",
                  transform: `translateX(-${currentSlide * 100}%)`,
                  transition: "transform 0.4s ease",
                }}
              >
                {cards.map((c) => (
                  <div
                    key={c.key}
                    style={{ flex: "0 0 100%", height: "100%", cursor: "pointer" }}
                    onClick={() => setSelectedImage(`${apiurl}/ProgressReport/${c.img}`)}
                  >
                    <img
                      src={`${apiurl}/ProgressReport/${c.img}`}
                      alt="Uploaded"
                      loading="lazy"
                      decoding="async"
                      style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                      }}
                    />
                  </div>
                ))}
              </div>

              {total > 1 && (
                <>
                  <button type="button" onClick={goPrev} style={arrowStyle("left")} aria-label="Previous">
                    <FaChevronLeft size={14} />
                  </button>
                  <button type="button" onClick={goNext} style={arrowStyle("right")} aria-label="Next">
                    <FaChevronRight size={14} />
                  </button>
                  <span
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      backgroundColor: "rgba(0,0,0,0.55)",
                      color: "#fff",
                      fontSize: "11px",
                      padding: "2px 8px",
                      borderRadius: "10px",
                    }}
                  >
                    {currentSlide + 1} / {total}
                  </span>
                </>
              )}
            </div>

            {total > 1 && (
              <div style={{ display: "flex", justifyContent: "center", gap: "6px", margin: "10px 0 4px" }}>
                {cards.map((c, i) => (
                  <span
                    key={c.key}
                    onClick={() => setCurrentSlide(i)}
                    style={{
                      width: i === currentSlide ? "18px" : "8px",
                      height: "8px",
                      borderRadius: "4px",
                      backgroundColor: i === currentSlide ? PHOTO_THEME.border : "#cfd4dc",
                      cursor: "pointer",
                      transition: "all 0.3s",
                    }}
                  />
                ))}
              </div>
            )}

            <div style={{ marginTop: "12px" }}>
              <PhotoInfoRow icon={<TbLocation />} label="Latitude" value={loc.latitude || "-"} />
              <PhotoInfoRow icon={<FaMapMarkerAlt />} label="Longitude" value={loc.longitude || "-"} />
              <PhotoInfoRow icon={<FaRegCalendarAlt />} label="Date" value={loc.date || "-"} />
              <PhotoInfoRow icon={<FaRegClock />} label="Time" value={loc.time || "-"} />
              <PhotoInfoRow
                icon={<FaMountain />}
                label="Elevation"
                value={`${loc.elevation && loc.elevation !== "-" ? loc.elevation : ""} m`}
              />
              <PhotoInfoRow
                icon={<FaBullseye />}
                label="Accuracy"
                value={`${loc.accuracy && loc.accuracy !== "-" ? loc.accuracy : ""} m`}
              />
              <PhotoInfoRow icon={<FaChartBar />} label="Work Done" value={`${current?.progress || "-"}%`} />
            </div>
          </div>
        ) : (
          <div style={{ textAlign: "center", padding: "40px 0", color: "#999" }}>No images found</div>
        )}

        <div className="text-center">
          <button
            type="button"
            onClick={() => setShowSpecific(0)}
            style={{ backgroundColor: "white", border: "1px solid blue" }}
            className="btn fw-bold px-4 my-3"
          >
            <img src="/Back-Arrow-32.jpg" alt="Back Icon" style={{ width: "25px", marginRight: "7px" }} />
            Back
          </button>
        </div>
      </div>
    );
  };

  /* =====================================================================
     RENDER: DASHBOARD HOME
     ===================================================================== */
  const renderHome = () => (
    <div className="agencyDash-page">
      <h5 className="agencyDash-page-title">
        <img src="/Dashboard-Blue-32.png" alt="" />
        Project Dashboard
      </h5>

      {/* ============ FILTER BAR (only Select Project, as in your code) ============ */}
      {canViewProjectSelect && (
        <div className="agencyDash-filter-bar">
          <div className="agencyDash-filter-group">
            <label className="agencyDash-filter-label">Select Project :</label>
            <Select
              {...DASH_SELECT_PROPS}
              options={projectOptions}
              value={selectedProjectOption}
              onChange={(o) => handleProjectChange(o ? o.value : "")}
              placeholder="Search / Choose Project"
              noOptionsMessage={() => "No project found"}
              styles={dashSelectStyles(250)}
            />
          </div>
        </div>
      )}

      {loading ? (
        <div className="agencyDash-loader" />
      ) : (
        <>
          {/* ============ TOP CARDS ============ */}
          <div className="agencyDash-card-grid">
            <DashStatCard
              theme="blue"
              icon="/Total-Project.png"
              title="Total Project Cost"
              value={rupee(displayData?.Project_Cost)}
              onClick={() => setShowTable("projectCost")}
            />
            <DashStatCard
              theme="purple"
              icon="/Total-Limit-Allocation.png"
              title="Total Limit Allocation"
              value={rupee(totalReleaseAmount)}
              onClick={() => setShowTable("releaseamount")}
            />
            <DashStatCard
              theme="orange"
              icon="/Total-Work-Orders-100.png"
              title="Total Work Orders"
              value={displayData?.TotalWorkOrders || totalWorkOrders || 0}
              onClick={() => setShowTable("workOrder")}
            />
            <DashStatCard
              theme="green"
              icon="/Total-Progress-Report-100.png"
              title="Total Progress Report"
              value={progressData.length}
              onClick={() => setShowTable("progress")}
            />
          </div>

          {/* ============ CHARTS + DEMAND / DEDUCTION CARDS ============ */}
          <div className="agencyDash-chart-grid">
            <div className="agencyDash-chart-card">
              <h5 className="agencyDash-chart-title">Total Spend</h5>
              <div className="agencyDash-spend">
                <div className="agencyDash-spend__summary">
                  <h1 className="agencyDash-spend__amount">₹37.5K</h1>
                  <div className="agencyDash-spend__row">
                    <p className="agencyDash-spend__label">
                      Total
                      <br />
                      Spend
                    </p>
                    <p className="agencyDash-spend__delta">+2.45%</p>
                  </div>
                  <h4 className="agencyDash-spend__status">On track</h4>
                </div>

                <div className="agencyDash-spend__chart">
                  <ReactApexChart type="area" height={300} width="100%" series={SPEND_SERIES} options={SPEND_OPTIONS} />
                </div>
              </div>
            </div>

            <div className="agencyDash-chart-card">
              <h5 className="agencyDash-chart-title">Taxes And Amounts</h5>
              <div className="agencyDash-taxes-chart">
                <div style={{ width: "100%", maxWidth: "330px" }}>
                  <ReactApexChart
                    options={deductionData && deductionData.length > 0 ? state5.options : state4.options}
                    series={deductionData && deductionData.length > 0 ? state5.series : state4.series}
                    type="donut"
                    width="100%"
                    height={250}
                  />
                </div>
              </div>
            </div>

            <div className="agencyDash-side-cards">
              <DashStatCard
                tall
                theme="teal"
                icon="/Total-Demand-Generations-100.png"
                title="Total Demand Generations"
                value={rupee(displayData?.LiabalityAmount)}
                onClick={() => setShowTable("demand")}
              />
              <DashStatCard
                tall
                theme="red"
                icon="/Total-Deduction-Amount.png"
                title="Total Deduction Amount"
                value={rupee(displayData?.TotalDeductionAmount)}
                onClick={() => {
                  setShowTable("deduction");
                  loadDeductionWorkOrders();
                }}
              />
            </div>
          </div>

          {/* ============ VENDOR BILLS + HEAD DETAILS ============ */}
          <div className="agencyDash-bottom-grid">
            <div className="agencyDash-panel">
              <h4 className="agencyDash-panel-title">Vendor Bills</h4>

              <div className="agencyDash-panel-scroll">
                <table className="agencyDash-mini-table">
                  <thead>
                    <tr>
                      <th>Bill Number</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Date</th>
                      <th>Progress</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vendorPg.items.length < 1 ? (
                      <tr>
                        <td colSpan={5} className="agencyDash-mini-empty">
                          No Bills Found
                        </td>
                      </tr>
                    ) : (
                      vendorPg.items.map((bill, i) => (
                        <tr key={i}>
                          <td>{bill.BillNumber}</td>
                          <td title={bill.Vendor_Company_Name || ""}>{bill.Vendor_Company_Name}</td>
                          <td>
                            <div className="agencyDash-status">
                              <img
                                alt=""
                                src={
                                  bill.Status === "Sent to Bank" || bill.Status === "Successful/Paid"
                                    ? Approved32
                                    : Disable32
                                }
                              />
                              <span>{bill.Status === "false" ? "Approvals Pending" : bill.Status}</span>
                            </div>
                          </td>
                          <td>{bill.UploadedOn?.slice(0, 10)}</td>
                          <td>
                            <div className="agencyDash-mini-bar">
                              <div className="agencyDash-mini-bar__fill" />
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {vendorbills.length > 0 && (
                <DashPagination compact page={vendorCurrentPage} totalPages={vendorPg.totalPages} onPage={setVendorCurrentPage} />
              )}
            </div>

            <div className="agencyDash-panel">
              <h4 className="agencyDash-panel-title">Head Details</h4>

              <div className="agencyDash-panel-scroll">
                <table className="agencyDash-mini-table">
                  <thead>
                    <tr>
                      <th style={{ width: "20%" }}>Sr. No</th>
                      <th style={{ width: "45%" }}>Budget Head</th>
                      <th style={{ width: "35%" }}>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {headPg.items.length > 0 ? (
                      headPg.items.map(([budgetHead, totalAmount], i) => (
                        <tr key={budgetHead + i}>
                          <td>{headPg.first + i + 1}</td>
                          <td title={budgetHead}>{budgetHead}</td>
                          <td>{rupee(totalAmount)}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3} className="agencyDash-mini-empty">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {headTableData.length > 0 && (
                <DashPagination compact page={headCurrentPage} totalPages={headPg.totalPages} onPage={setHeadCurrentPage} />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );

  /* =====================================================================
     RENDER: DRILL-DOWN TABLE PAGE
     ===================================================================== */
  const renderDeductionDetails = () => (
    <div className="agencyDash-table-card">
      <div className="agencyDash-table-scroll">
        <h5 style={{ margin: "14px 16px" }}>Work Order: {selectedWorkOrder}</h5>
        <table className="agencyDash-table">
          <thead>
            <tr>
              <th>Sr.No</th>
              <th>Deduction Name</th>
              <th>Deduction Amount</th>
            </tr>
          </thead>
          <tbody>
            {deductionDetailsPg.items.map((item, index) => (
              <tr key={item.ID ?? index}>
                <td>{deductionDetailsPg.first + index + 1}</td>
                <td>{item.DeductionName || "-"}</td>
                <td className="agencyDash-cell-amount">{fmt(item.DeductionAmount)}</td>
              </tr>
            ))}
            {deductionDetailsList.length > 0 && (
              <tr className="agencyDash-total-row">
                <td colSpan={2}>Total</td>
                <td>
                  {fmt(deductionDetails.reduce((sum, item) => sum + Number(item.DeductionAmount || 0), 0))}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {deductionDetailsList.length === 0 && <div className="agencyDash-empty">No Deduction Details Found</div>}
      </div>

      {deductionDetailsList.length > 0 && (
        <DashPagination
          page={deductionDetailsPage}
          totalPages={deductionDetailsPg.totalPages}
          onPage={setDeductionDetailsPage}
          info={`Showing ${deductionDetailsPg.first + 1} to ${Math.min(
            deductionDetailsPg.last,
            deductionDetailsList.length,
          )} of ${deductionDetailsList.length} entries`}
        />
      )}
    </div>
  );

  const renderTableBody = () => {
    if (showTable === "deduction" && selectedWorkOrder !== "") return renderDeductionDetails();

    const v = tableViews[showTable];
    if (!v) return null;

    return (
      <div className="agencyDash-table-card">
        <div className="agencyDash-table-scroll">
          <table className="agencyDash-table">
            <thead>
              <tr>
                <th>Sr.No</th>
                {v.cols.map((c) => (
                  <th key={c.head}>{c.head}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {v.pg.items.map((item, i) => (
                <tr key={item.ID ?? i}>
                  <td>{v.pg.first + i + 1}</td>
                  {v.cols.map((c) => (
                    <td key={c.head} className={c.link ? "agencyDash-cell-link" : c.amount ? "agencyDash-cell-amount" : undefined}>
                      {c.cell(item)}
                    </td>
                  ))}
                </tr>
              ))}

              {v.footer && v.list.length > 0 && (
                <tr className="agencyDash-total-row">
                  <td colSpan={v.footer.span}>Total</td>
                  <td>{v.footer.value}</td>
                  {Array.from({ length: v.footer.after }).map((_, i) => (
                    <td key={i} />
                  ))}
                </tr>
              )}
            </tbody>
          </table>

          {v.pg.items.length === 0 && <div className="agencyDash-empty">{v.empty}</div>}
        </div>

        {v.list.length > 0 && (
          <DashPagination
            page={v.page}
            totalPages={v.pg.totalPages}
            onPage={v.setPage}
            info={`Showing ${v.pg.first + 1} to ${Math.min(v.pg.last, v.list.length)} of ${v.list.length} entries`}
          />
        )}
      </div>
    );
  };

  const renderTablePage = () => (
    <div className="agencyDash-table-page">
      <div className="agencyDash-table-head">
        <div className="agencyDash-table-head__left">
          <button type="button" className="agencyDash-back-btn" onClick={handleBack} aria-label="Back">
            <span className="agencyDash-back-btn__icon">
              <FaUndoAlt />
            </span>
          </button>
          <h4 className="agencyDash-table-title">{TABLE_TITLES[showTable]}</h4>
        </div>

        <div className="agencyDash-search">
          <img src="/Search-32.png" alt="" className="agencyDash-search-icon" />
          <input
            type="text"
            className="agencyDash-search-input"
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>

      {renderTableBody()}
    </div>
  );

  /* =====================================================================
     RETURN
     ===================================================================== */
  return (
    <>
      {showSpecific === 1 ? renderPhotoViewer() : showTable === null ? renderHome() : renderTablePage()}

      {selectedImage && (
        <div className="agencyDash-photo-lightbox" onClick={() => setSelectedImage(null)}>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(null);
            }}
            style={{
              position: "absolute",
              top: "20px",
              right: "25px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: "rgba(255,255,255,0.9)",
              color: "#000",
              fontSize: "25px",
              fontWeight: "bold",
              cursor: "pointer",
              zIndex: 100000,
            }}
          >
            ×
          </button>
          <img
            src={selectedImage}
            alt="Uploaded Progress Report"
            draggable={false}
            onClick={(e) => e.stopPropagation()}
            style={{
              display: "block",
              width: "auto",
              height: "auto",
              maxWidth: "95vw",
              maxHeight: "95vh",
              objectFit: "contain",
              borderRadius: "6px",
              boxShadow: "0 0 20px rgba(255,255,255,0.25)",
            }}
          />
        </div>
      )}
    </>
  );
};

export default AgencyDashboard;